import React, { useEffect, useRef, useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ClearIcon from "@mui/icons-material/Clear";
import {
  Modal,
  Box,
  Button,
  Paper,
  InputBase,
  Tooltip,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";
import "../CompetitiveIntelligence/CompetitiveIntelligence.css";
import {
  APIDataUrl,
  APITokenUrl,
  GetOktaAuthData,
  GetUserId,
} from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import halflines from "../../Assets/halflines.svg";
import search from "../../Assets/search.svg";
import Loader from "../Loader/Loader";
import print from "../../Assets/print.svg";
import download from "../../Assets/downloadcv.png";
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import SearchIcon from "@mui/icons-material/Search";
import KeywordFilterModal from "./KeywordFilterModal";
import { CloseOutlined } from "@mui/icons-material";
import HeaderSearch from "../Header/Search/Search";
import CompetitiveSlider from "./CompetitiveSlider";
import CompetitiveSliderTwo from "./CompetitiveSliderTwo";
import CompetitiveSliderThree from "./CompetitiveSliderThree";
// import CompetitiveSliderTab from "./CompetitiveSliderTab";

const CompetitiveIntelligence = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [cities, setCities] = useState();
  const [value, setValue] = useState(1);
  const boxOneRef = useRef();
  const boxTwoRef = useRef();
  const boxThreeRef = useRef();
  const [loading, setLoading] = React.useState(false);
  const userInfo = GetOktaAuthData();
  const loggedUser = userInfo?.user?.profile;
  const [feedBoxOne, setFeedBoxOne] = React.useState([]);
  const [feedBoxTwo, setFeedBoxTwo] = React.useState([]);
  const [feedBoxThree, setFeedBoxThree] = React.useState([]);
  const [openSearchOne, setOpenSearchOne] = useState(false);
  const [openSearchTwo, setOpenSearchTwo] = useState(false);
  const [openSearchThree, setOpenSearchThree] = useState(false);
  const [dateOrderOne, setDateOrderOne] = React.useState("desc");
  const [dateOrderTwo, setDateOrderTwo] = React.useState("desc");
  const [dateOrderThree, setDateOrderThree] = React.useState("desc");
  const [saveSearchOne, setSaveSearchOne] = useState([""]);
  const [saveSearchTwo, setSaveSearchTwo] = useState([""]);
  const [saveSearchThree, setSaveSearchThree] = useState([""]);
  const [common, setCommon] = useState(false);
  const [skipOne, setSkipOne] = useState(0);
  const [skipTwo, setSkipTwo] = useState(0);
  const [skipThree, setSkipThree] = useState(0);
  const [loadOne, setLoadOne] = useState(false);
  const [loadTwo, setLoadTwo] = useState(false);
  const [loadThree, setLoadThree] = useState(false);
  const [keywordListOne, setKeywordListOne] = useState([]);
  const [keywordListTwo, setKeywordListTwo] = useState([]);
  const [keywordListThree, setKeywordListThree] = useState([]);
  const [keywordSelectedOne, setKeywordSelectedOne] = useState([]);
  const [keywordSelectedTwo, setKeywordSelectedTwo] = useState([]);
  const [keywordSelectedThree, setKeywordSelectedThree] = useState([]);
  const [searchOneApi, setSearchOneApi] = useState(false);
  const [searchTwoApi, setSearchTwoApi] = useState(false);
  const [searchThreeApi, setSearchThreeApi] = useState(false);
  const [keywordAddModalOne, setKeywordAddModalOne] = useState(false);
  const [keywordAddModalTwo, setKeywordAddModalTwo] = useState(false);
  const [keywordAddModalThree, setKeywordAddModalThree] = useState(false);
  const [expandedSummaryOne, setExpandedSummaryOne] = useState({});
  const [expandedSummaryTwo, setExpandedSummaryTwo] = useState({});
  const [expandedSummaryThree, setExpandedSummaryThree] = useState({});
  const [openCompetitiveSlide, setOpenCompetitiveSlide] = useState(false);
  const [openCompetitiveSlideTab, setOpenCompetitiveSlideTab] = useState(false);
  const [openCompetitiveSlideTabTwo, setOpenCompetitiveSlideTabTwo] =
    useState(false);
  const [openCompetitiveSlideTabThree, setOpenCompetitiveSlideTabThree] =
    useState(false);
  const [openCompetitiveSlideTwo, setOpenCompetitiveSlideTwo] = useState(false);
  const [openCompetitiveSlideThree, setOpenCompetitiveSlideThree] =
    useState(false);

  const handleOpenSlider = () => {
    setOpenCompetitiveSlide(true);
  };
  const handleOpenSliderTab = () => {
    setOpenCompetitiveSlideTab(true);
  };
  const handleOpenSliderTabTwo = () => {
    setOpenCompetitiveSlideTabTwo(true);
  };

  const handleOpenSliderTabThree = () => {
    setOpenCompetitiveSlideTabThree(true);
  };
  const handleOpenSliderTwo = () => {
    setOpenCompetitiveSlideTwo(true);
  };
  const handleOpenSliderThree = () => {
    setOpenCompetitiveSlideThree(true);
  };
  const toggleSummaryOne = (index) => {
    setExpandedSummaryOne((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const toggleSummaryTwo = (index) => {
    setExpandedSummaryTwo((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const toggleSummaryThree = (index) => {
    setExpandedSummaryThree((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 650,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  const handleOpen = (i) => {
    setValue(i);
    setModalOpen(true);
    setCommon(true);
  };

  const handleClose = () => {
    setOrgLimit(50);
    setSkipOrganization(0);
    setSkipPeople(0);
    setOrgLimitPeople(50);
    setAllOrgList([]);
    setAllPeopleList([]);
    setModalOpen(false);
    setCommon(false);
    setValueOrganization(false);
    setValueIndustrySector(false);
    setValueKeywordTracking(false);
    setValuePeople(false);
    setValueStates(false);
    setValueCustomSearch(false);
    setSelectedPeople(null);
    setSearchTextPeople("");
    setSelectedOrg(null);
    setSearchTextOrg("");
    setSelectedState(null);
    setSearchTextState("");
    setSelectedKeyword([]);
    setSearchTextKeyword("");
    setSelectedIndustry([]);
    setSearchTextIndustry("");
    setSelectedCustomSearch(null);
    setSearchTextCustomSearch("");
    setOpenStateLegislation(false);
    setSelectedStateLegislation("news");
  };
  //people started
  const [valuePeople, setValuePeople] = useState(false);
  const [selectedPeople, setSelectedPeople] = React.useState(null);
  const [searchTextPeople, setSearchTextPeople] = useState("");
  const [allPeopleList, setAllPeopleList] = useState([]);
  const filteredPeoples = allPeopleList?.filter((location) =>
    `${location?.first_name} ${location?.last_name}`
      ?.toLowerCase()
      .includes(searchTextPeople?.toLowerCase()),
  );
  const handlePeopleClick = (people) => {
    setSelectedPeople(people);
    setSearchTextPeople(`${people?.first_name} ${people?.last_name}`);
  };
  const [orgLimitPeople, setOrgLimitPeople] = useState(50);
  const [skipPeople, setSkipPeople] = useState(0);
  const [peopleModalCount, setPeopleModalCount] = useState();
  const [peopleLoadMore, setPeopleLoadMore] = useState(true);
  const handleTrackingProspects = (skip = 0, limit = 50, isSearch, query) => {
    const q =
      query !== undefined
        ? query?.split(" ")?.[0]
        : searchTextPeople?.split(" ")?.[0];
    const options = {
      method: "POST",

      headers: {
        "Content-Type": "application/json",

        "access-control-allow-origin": "*",

        "X-API-Key": APITokenUrl(),
      },

      url: `${APIDataUrl()}/v1/search_get_tracked_org_people?type=person${
        q ? `&q=${q}` : ""
      }&skip=${skip}&limit=${limit}`,
    };

    axios(options)
      .then((response) => {
        setLoading(false);

        setPeopleModalCount(response?.data?.count);

        if (response?.data?.data?.length < limit) {
          setPeopleLoadMore(false);
        } else {
          setPeopleLoadMore(true);
        }

        if (isSearch) {
          setAllPeopleList(response?.data?.data);
        } else {
          setAllPeopleList((prev) => [...prev, ...response?.data?.data]);
        }
      })

      .catch((error) => {
        setLoading(false);

        toast.error(error?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (searchTextPeople?.length >= 2) {
      const timer = setTimeout(() => {
        handleTrackingProspects(0, 50, true);
      }, 1000);

      return () => clearTimeout(timer);
    } else if (searchTextPeople?.length === 0) {
      handleTrackingProspects(0, 50, true);
    }
  }, [searchTextPeople]);

  const handleOpenPeople = () => {
    setValuePeople(true);
    setCommon(false);
  };
  const handleBackPeople = () => {
    setOrgLimit(50);
    setSkipOrganization(0);
    setSkipPeople(0);
    setOrgLimitPeople(50);
    setValueOrganization(false);
    setValueIndustrySector(false);
    setValueKeywordTracking(false);
    setValuePeople(false);
    setValueStates(false);
    setValueCustomSearch(false);
    setSelectedPeople(null);
    setSearchTextPeople("");
    setCommon(true);
  };
  //people ended

  //organization Started
  const [valueOrganization, setValueOrganization] = useState(false);
  const [selectedOrg, setSelectedOrg] = React.useState(null);
  const [searchTextOrg, setSearchTextOrg] = useState("");
  const [allOrgList, setAllOrgList] = useState([]);

  const handleOrgClick = (keyword) => {
    setSelectedOrg(keyword);
    setSearchTextOrg(keyword?.organization_name);
  };
  const [orgLimit, setOrgLimit] = useState(50);
  const [skipOrganization, setSkipOrganization] = useState(0);
  const [organizationModalCount, setOrganizationModalCount] = useState();
  const [orgLoadMore, setOrgLoadMore] = useState(true);
  const handleTrackingOrganizations = (
    skip = 0,
    limit = 50,
    isSearch,
    query,
  ) => {
    const q = query !== undefined ? query : searchTextOrg;
    const options = {
      method: "POST",

      headers: {
        "Content-Type": "application/json",

        "access-control-allow-origin": "*",

        "X-API-Key": APITokenUrl(),
      },

      url: `${APIDataUrl()}/v1/search_get_tracked_org_people?type=organization${
        q ? `&q=${q}` : ""
      }&skip=${skip}&limit=${limit}`,
    };

    axios(options)
      .then((response) => {
        setLoading(false);

        setOrganizationModalCount(response?.data?.count);

        if (response?.data?.data?.length < limit) {
          setOrgLoadMore(false);
        } else {
          setOrgLoadMore(true);
        }

        if (isSearch) {
          setAllOrgList(response?.data?.data);
        } else {
          setAllOrgList((prev) => [...prev, ...response?.data?.data]);
        }
      })

      .catch((error) => {
        setLoading(false);

        toast.error(error?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (searchTextOrg?.length >= 2) {
      const timer = setTimeout(() => {
        handleTrackingOrganizations(0, 50, true);
      }, 1000);

      return () => clearTimeout(timer);
    } else if (searchTextOrg?.length === 0) {
      handleTrackingOrganizations(0, 50, true);
    }
  }, [searchTextOrg]);

  const handleOpenOrganization = () => {
    setValueOrganization(true);
    setCommon(false);
  };
  const handleBackorg = () => {
    setOrgLimit(50);
    setSkipOrganization(0);
    setSkipPeople(0);
    setOrgLimitPeople(50);
    setValueOrganization(false);
    setValueIndustrySector(false);
    setValueKeywordTracking(false);
    setValuePeople(false);
    setValueStates(false);
    setValueCustomSearch(false);
    setSelectedOrg(null);
    setSearchTextOrg("");
    setCommon(true);
  };
  //organization ended

  // States Started
  const [searchTextState, setSearchTextState] = useState("");
  const [selectedState, setSelectedState] = React.useState(null);
  const [valueStates, setValueStates] = useState(false);
  const [openStateLegislation, setOpenStateLegislation] = useState(false);
  const [selectedStateLegislation, setSelectedStateLegislation] =
    useState("news");
  let CompetitiveStatesList = [
    "Arizona",
    "California",
    "Florida",
    "Georgia",
    "Illinois",
    "Indiana",
    "Kentucky",
    "Michigan",
    "New York",
    "North Carolina",
    "Pennsylvania",
    "South Carolina",
    "Tennessee",
    "Texas",
    "Virginia",
    "West Virginia",
    "Wisconsin",
  ];
  const handleStatesClick = (keyword) => {
    setSelectedState(keyword);
    setSearchTextState(keyword);
  };
  const filteredStates = cities?.filter((location) =>
    location.toLowerCase().includes(searchTextState?.toLowerCase()),
  );

  const getCities = () => {
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: {},
      url: `${APIDataUrl()}/v1/get_cities`,
    };

    axios(options)
      .then((response) => {
        let dtaa = response.data.data.sort((a, b) =>
          a.toLowerCase().localeCompare(b.toLowerCase()),
        );
        setCities(dtaa || []);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching cities:", error);
        toast.error(
          error?.response?.data?.detail || error?.response?.data?.message,
        );
      });
  };

  const handleOpenStates = (i) => {
    setValueStates(true);
    setCommon(false);
  };
  const handleBackStates = () => {
    setValueOrganization(false);
    setValueIndustrySector(false);
    setValueKeywordTracking(false);
    setValuePeople(false);
    setValueStates(false);
    setValueCustomSearch(false);
    setSelectedState(null);
    setSearchTextState("");
    setOpenStateLegislation(false);
    setCommon(true);
  };
  //states ended

  //keyword started
  const [valueKeywordTracking, setValueKeywordTracking] = useState(false);
  const [selectedKeyword, setSelectedKeyword] = React.useState([]);
  const [searchTextKeyword, setSearchTextKeyword] = useState("");
  const [allKeywordList, setAllKeywordList] = useState([]);
  const filteredKeywords = allKeywordList?.filter((location) =>
    location.toLowerCase().includes(searchTextKeyword.toLowerCase()),
  );
  const handleKeywordCheckboxChange = (event, item) => {
    if (event.target.checked) {
      setSelectedKeyword([...selectedKeyword, item]);
    } else {
      setSelectedKeyword(
        selectedKeyword?.filter((uncheck) => uncheck !== item),
      );
    }
  };
  const handleKeywordList = () => {
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_keywords`,
    };

    axios(options)
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          const data = response?.data?.keywords?.sort();
          setAllKeywordList(data);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const handleOpenKeywordTracking = (i) => {
    setValueKeywordTracking(true);
    setCommon(false);
  };
  const handleBackKeyword = () => {
    setValueOrganization(false);
    setValueIndustrySector(false);
    setValueKeywordTracking(false);
    setValuePeople(false);
    setValueStates(false);
    setValueCustomSearch(false);
    setSelectedKeyword([]);
    setSearchTextKeyword("");
    setCommon(true);
  };

  //keyword ended

  //industry started
  const [valueIndustrySector, setValueIndustrySector] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = React.useState([]);
  const [searchTextIndustry, setSearchTextIndustry] = useState("");

  const industriesList = [
    "Advanced Manufacturing",
    "Aerospace and Aviation",
    "Automotive",
    "Federal and Military",
    "Financial Services",
    "Food Sciences and Agriculture",
    "Healthcare",
    "Information Services and Software",
    "Logistics and Distribution",
    "Shale Energy and Petrochemicals",
  ];

  const filteredIndustries = industriesList?.filter((location) =>
    location.toLowerCase().includes(searchTextIndustry.toLowerCase()),
  );
  const handleIndustryCheckboxChange = (event, item) => {
    if (event.target.checked) {
      setSelectedIndustry([...selectedIndustry, item]);
    } else {
      setSelectedIndustry(
        selectedIndustry?.filter((uncheck) => uncheck !== item),
      );
    }
  };
  const handleOpenIndustrySector = (i) => {
    setValueIndustrySector(true);
    setCommon(false);
  };
  const handleBackIndustry = () => {
    setValueOrganization(false);
    setValueIndustrySector(false);
    setValueKeywordTracking(false);
    setValuePeople(false);
    setValueStates(false);
    setValueCustomSearch(false);
    setSelectedIndustry([]);
    setSearchTextIndustry("");
    setCommon(true);
  };
  //industry ended

  //custom search started
  const [valueCustomSearch, setValueCustomSearch] = useState(false);
  const [selectedCustomSearch, setSelectedCustomSearch] = React.useState(null);
  const [searchTextCustomSearch, setSearchTextCustomSearch] = useState("");
  const [allCustomSearchList, setAllCustomSearchList] = useState([]);
  const filteredCustomSearchs = allCustomSearchList?.filter((location) =>
    `${location?.custom_query_name}`
      .toLowerCase()
      .includes(searchTextCustomSearch.toLowerCase()),
  );
  const handleCustomSearchClick = (CustomSearch) => {
    setSelectedCustomSearch(CustomSearch);
    setSearchTextCustomSearch(CustomSearch?.custom_query_name);
  };
  const handleCustomSearchData = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_tracking?user_id=${Number(GetUserId())}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = e?.data?.data;
        setAllCustomSearchList(
          data
            ?.filter((i) => i?.request_type === "custom_search")
            ?.filter(
              (i) =>
                new Date(i.track_until).toISOString().split("T")[0] >
                new Date().toISOString().split("T")[0],
            ),
        );
      })
      .catch((err) => {});
  };
  const handleOpenCustomSearch = (i) => {
    setValueCustomSearch(true);
    setCommon(false);
  };
  const handleBackCustomSearch = () => {
    setValueOrganization(false);
    setValueIndustrySector(false);
    setValueKeywordTracking(false);
    setValuePeople(false);
    setValueStates(false);
    setValueCustomSearch(false);
    setSelectedCustomSearch(null);
    setSearchTextCustomSearch("");
    setCommon(true);
  };
  //custom search ended
  useEffect(() => {
    if (modalOpen === true) {
      handleKeywordList();
      handleTrackingOrganizations();
      handleTrackingProspects();
      getCities();
    }
  }, [modalOpen]);

  const getNews = (item, type, word) => {
    //skip
    const skipVal =
      item?.content_box_id === 1
        ? skipOne
        : item?.content_box_id === 2
          ? skipTwo
          : skipThree;
    //sort
    const sorrt =
      item?.content_box_id === 1
        ? dateOrderOne
        : item?.content_box_id === 2
          ? dateOrderTwo
          : dateOrderThree;

    setLoading(true);
    //keyword
    const keyword =
      item?.content_box_id === 1
        ? keywordSelectedOne
        : item?.content_box_id === 2
          ? keywordSelectedTwo
          : keywordSelectedThree;
    const tagsdata = [
      ...(keyword?.length ? keyword : []),
      ...(item?.tags?.length ? [item.tags] : []),
    ].join(", ");
    const tags =
      word === "word"
        ? [...(item?.tags?.length ? [item.tags] : [])].join(", ")
        : tagsdata;

    let peopleQuery = `${
      item?.people_id !== 0 && item?.people_id !== null ? "&people_id=" : ""
    }${
      item?.people_id !== 0 && item?.people_id !== null ? item?.people_id : ""
    }`;
    let orgQuery = `${
      item?.org_id !== 0 && item?.org_id !== null ? "&org_id=" : ""
    }${item?.org_id !== 0 && item?.org_id !== null ? item?.org_id : ""}`;
    // let stateQuery = `${item?.location?.length ? "&location=" : ""}${item?.location?.length ? item.location : ''}`
    let keywordQuery = `${tags?.length ? "&tags=" : ""}${
      tags?.length ? tags : ""
    }`;
    // let industryQuery = `${item?.industry?.length ? "&industry=" : ""}${item?.industry?.length ? item.industry : ''}`
    let customsearchQuery = `${
      item?.request_id !== 0 && item?.request_id !== null ? "&request_id=" : ""
    }${
      item?.request_id !== 0 && item?.request_id !== null ? item.request_id : ""
    }`;
    let locationQuery = `${
      item?.document_type === "news" && item?.location?.length
        ? "&location="
        : ""
    }${
      item?.document_type === "news" && item?.location?.length
        ? item?.location
        : ""
    }`;
    let allQuery =
      peopleQuery + orgQuery + keywordQuery + customsearchQuery + locationQuery;

    let data = {};
    if (item?.industry?.length) {
      data.industry = item.industry?.split(",");
    }
    if (item?.location?.length && item?.document_type === "legislation") {
      data.measure_req = {
        measure_type: ["legislation"],
        state: item?.location?.split(","),
      };
    }
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/get_news?sort_order=${sorrt}&limit=10&skip=${
        type === "date" ? 0 : skipVal
      }&document_type=${
        item?.document_type === "legislation" ? "legislation" : "news"
      }${allQuery}`,
    };
    axios(options)
      .then((e) => {
        if (item?.content_box_id === 1) {
          if (e?.data?.items?.length < 10 || e?.data?.data?.length < 10) {
            setLoadOne(false);
          } else {
            setLoadOne(true);
          }
          const newData = feedBoxOne?.data || [];
          setKeywordListOne(e?.data?.tags || []);
          if (type == "tag" || type == "date") {
            setFeedBoxOne({
              data: e?.data?.items?.length
                ? [...e?.data?.items]
                : [...(e?.data?.data || [])],
              boxData: item,
            });
          } else {
            setFeedBoxOne({
              data: e?.data?.items?.length
                ? [...newData, ...e?.data?.items]
                : [...newData, ...(e?.data?.data || [])],
              boxData: item,
            });
          }
        } else if (item?.content_box_id === 2) {
          if (e?.data?.items?.length < 10 || e?.data?.data?.length < 10) {
            setLoadTwo(false);
          } else {
            setLoadTwo(true);
          }
          const newData = feedBoxTwo?.data || [];
          setKeywordListTwo(e?.data?.tags || []);
          if (type == "tag" || type == "date") {
            setFeedBoxTwo({
              data: e?.data?.items?.length
                ? [...e?.data?.items]
                : [...(e?.data?.data || [])],
              boxData: item,
            });
          } else {
            setFeedBoxTwo({
              data: e?.data?.items?.length
                ? [...newData, ...e?.data?.items]
                : [...newData, ...(e?.data?.data || [])],
              boxData: item,
            });
          }
        } else if (item?.content_box_id === 3) {
          if (e?.data?.items?.length < 10 || e?.data?.data?.length < 10) {
            setLoadThree(false);
          } else {
            setLoadThree(true);
          }
          const newData = feedBoxThree?.data || [];
          setKeywordListThree(e?.data?.tags || []);
          if (type == "tag" || type == "date") {
            setFeedBoxThree({
              data: e?.data?.items?.length
                ? [...e?.data?.items]
                : [...(e?.data?.data || [])],
              boxData: item,
            });
          } else {
            setFeedBoxThree({
              data: e?.data?.items?.length
                ? [...newData, ...e?.data?.items]
                : [...newData, ...(e?.data?.data || [])],
              boxData: item,
            });
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (skipOne > 0 && !searchOneApi) {
      getNews(feedBoxOne?.boxData);
    } else if (skipOne > 0 && searchOneApi) {
      handleSearchSave(1);
    }
  }, [skipOne]);
  useEffect(() => {
    if (dateOrderOne && feedBoxOne?.boxData?.id && !searchOneApi) {
      setSkipOne(0);
      getNews(feedBoxOne?.boxData, "date");
    }
  }, [dateOrderOne]);
  useEffect(() => {
    if (
      keywordSelectedOne?.length &&
      feedBoxOne?.boxData?.id &&
      !searchOneApi
    ) {
      setSkipOne(0);
      getNews(feedBoxOne?.boxData, "date");
    } else {
    }
  }, [keywordSelectedOne?.length]);
  useEffect(() => {
    if (
      keywordSelectedTwo?.length &&
      feedBoxTwo?.boxData?.id &&
      !searchTwoApi
    ) {
      setSkipTwo(0);
      getNews(feedBoxTwo?.boxData, "date");
    } else {
    }
  }, [keywordSelectedTwo?.length]);
  useEffect(() => {
    if (
      keywordSelectedThree?.length &&
      feedBoxThree?.boxData?.id &&
      !searchThreeApi
    ) {
      setSkipThree(0);
      getNews(feedBoxThree?.boxData, "date");
    } else {
    }
  }, [keywordSelectedThree?.length]);

  useEffect(() => {
    if (skipTwo > 0 && !searchTwoApi) {
      getNews(feedBoxTwo?.boxData);
    } else if (skipTwo > 0 && searchTwoApi) {
      handleSearchSave(2);
    }
  }, [skipTwo]);
  useEffect(() => {
    if (dateOrderTwo && feedBoxTwo?.boxData?.id && !searchTwoApi) {
      setSkipTwo(0);
      getNews(feedBoxTwo?.boxData, "date");
    }
  }, [dateOrderTwo]);
  useEffect(() => {
    if (skipThree > 0 && !searchThreeApi) {
      getNews(feedBoxThree?.boxData);
    } else if (skipThree > 0 && searchThreeApi) {
      handleSearchSave(3);
    }
  }, [skipThree]);
  useEffect(() => {
    if (dateOrderThree && feedBoxThree?.boxData?.id && !searchThreeApi) {
      setSkipThree(0);
      getNews(feedBoxThree?.boxData, "date");
    }
  }, [dateOrderThree]);

  const validate = () => {
    if (valueOrganization && !selectedOrg?.org_id) {
      toast.error("Please Select Organization");
      return false;
    }
    if (valuePeople && !selectedPeople?.person_id) {
      toast.error("Please Select Prospect");
      return false;
    }
    if (valueKeywordTracking && !selectedKeyword?.length) {
      toast.error("Please Select keyword");
      return false;
    }
    if (!selectedState?.length && valueStates) {
      toast.error("Please Select State ");
      return false;
    }
    if (!selectedState?.length && openStateLegislation) {
      toast.error("Please Select State ");
      return false;
    }
    if (valueIndustrySector && !selectedIndustry?.length) {
      toast.error("Please Select industry");
      return false;
    }
    if (valueCustomSearch && !selectedCustomSearch?.request_id) {
      toast.error("Please Select Custom Search");
      return false;
    }
    return true;
  };

  const saveContentFeed = () => {
    if (!validate()) return;
    const data = {
      id: 0,
      user_id: GetUserId(),
      context_box: value,
      people_id: selectedPeople ? selectedPeople?.person_id : 0,
      request_id: selectedCustomSearch ? selectedCustomSearch?.request_id : 0,
      org_id: selectedOrg ? selectedOrg?.org_id : 0,
      location: selectedState ? selectedState : "",
      tags: selectedKeyword?.length ? selectedKeyword?.join(", ") : "",
      industry: selectedIndustry?.length ? selectedIndustry?.join(", ") : "",
      document_type: selectedStateLegislation,
    };

    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/save_feed_box`,
    };

    axios(options)
      .then(() => {
        handleClose();
        getContentFeed(value, "save");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const getContentFeed = (value, type) => {
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_feed_box?user_id=${GetUserId()}`,
    };
    axios(options)
      .then((e) => {
        let data = e?.data;
        if (data?.length < 1) {
          setLoading(false);
        }
        if (value && type === "save") {
          const check = data?.find((item) => item?.content_box_id === value);
          if (check?.id) {
            getNews(check, "tag");
          }
        } else if (value && type === "del") {
          if (value === 1) {
            setFeedBoxOne({ data: [], boxData: {} });
          } else if (value === 2) {
            setFeedBoxTwo({ data: [], boxData: {} });
          } else if (value === 3) {
            setFeedBoxThree({ data: [], boxData: {} });
          }
          setLoading(false);
        } else {
          data?.forEach((item) => {
            getNews(item);
          });
        }
      })
      .catch((error) => {
        // toast.error(error?.response?.data?.message );
      });
  };
  useEffect(() => {
    getContentFeed();
    handleCustomSearchData();
  }, []);
  const handleRemoveFeed = (item) => {
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/delete_feed_box?box_id=${item?.id}`,
    };
    axios(options)
      .then((e) => {
        getContentFeed(item?.content_box_id, "del");
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const HandlePrintOne = useReactToPrint({
    content: () => boxOneRef.current,
  });
  const HandlePrintTwo = useReactToPrint({
    content: () => boxTwoRef.current,
  });
  const HandlePrintThree = useReactToPrint({
    content: () => boxThreeRef.current,
  });
  const handleToPDF = (item) => {
    const content =
      item === 1
        ? boxOneRef.current
        : item === 2
          ? boxTwoRef.current
          : boxThreeRef.current;
    const options = {
      filename: "newsFeed.pdf",
      margin: 10,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: {
        format: "letter",
        orientation: "portrait",
      },
    };
    html2pdf().set(options).from(content).save();
  };

  const handleChangeFeedBoxOne = (event) => {
    setDateOrderOne(event.target.value);
  };
  const handleChangeFeedBoxTwo = (event) => {
    setDateOrderTwo(event.target.value);
  };
  const handleChangeFeedBoxThree = (event) => {
    setDateOrderThree(event.target.value);
  };
  const initialData = (item) => {
    const data = item?.split(" ");
    return `${data?.[0]?.charAt(0).toUpperCase() || ""}${
      data?.[1]?.charAt(0).toUpperCase() || ""
    }`;
  };

  const handleSearchSave = (e, type) => {
    const data =
      e == 1
        ? [saveSearchOne]
        : e == 2
          ? [saveSearchTwo]
          : e == 3
            ? [saveSearchThree]
            : [];
    const selected =
      e == 1
        ? feedBoxOne?.boxData
        : e == 2
          ? feedBoxTwo?.boxData
          : e == 3
            ? feedBoxThree?.boxData
            : "";
    const skipVal =
      e === 1 ? skipOne : e === 2 ? skipTwo : e === 3 ? skipThree : "";
    setLoading(true);
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
        "Content-Type": "application/json",
      },
      data: data,
      url: `${APIDataUrl()}/v1/custom_search?limit=10${
        selected?.org_id !== null ? "&entity_id=" : ""
      }${selected?.org_id !== null ? selected?.org_id : ""}${
        selected?.people_id !== 0 ? "&entity_id=" : ""
      }${selected?.people_id !== 0 ? selected?.people_id : ""}&skip=${
        type === "first" ? 0 : skipVal
      }&keyword=${data?.[0]}`,
    };

    axios(options)
      .then((response) => {
        if (e == 1) {
          if (response?.data?.length < 10) {
            setLoadOne(false);
          } else {
            setLoadOne(true);
          }
          setSearchOneApi(true);
          const newData = feedBoxOne?.data || [];
          // setKeywordListOne(e?.data?.tags)
          if (type == "first") {
            setFeedBoxOne({
              data: [...response.data],
              boxData: feedBoxOne?.boxData,
            });
          } else {
            setFeedBoxOne({
              data: [...newData, ...response.data],
              boxData: feedBoxOne?.boxData,
            });
          }
        } else if (e == 2) {
          if (response?.data?.length < 10) {
            setLoadTwo(false);
          } else {
            setLoadTwo(true);
          }
          setSearchTwoApi(true);
          const newData = feedBoxTwo?.data || [];
          if (type == "first") {
            setFeedBoxTwo({
              data: [...response.data],
              boxData: feedBoxTwo?.boxData,
            });
          } else {
            setFeedBoxTwo({
              data: [...newData, ...response.data],
              boxData: feedBoxTwo?.boxData,
            });
          }
        } else {
          if (response?.data?.length < 10) {
            setLoadThree(false);
          } else {
            setLoadThree(true);
          }
          setSearchThreeApi(true);
          const newData = feedBoxTwo?.data || [];
          if (type == "first") {
            setFeedBoxThree({
              data: [...response.data],
              boxData: feedBoxThree?.boxData,
            });
          } else {
            setFeedBoxThree({
              data: [...newData, ...response.data],
              boxData: feedBoxThree?.boxData,
            });
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (saveSearchOne?.length > 2) {
      const timer = setTimeout(() => {
        setKeywordSelectedOne([]);
        handleSearchSave(1, "first");
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [saveSearchOne]);
  useEffect(() => {
    if (saveSearchTwo?.length > 2) {
      const timer = setTimeout(() => {
        handleSearchSave(2, "first");
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [saveSearchTwo]);
  useEffect(() => {
    if (saveSearchThree?.length > 2) {
      const timer = setTimeout(() => {
        handleSearchSave(3, "first");
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [saveSearchThree]);

  const truncateText = (text) => {
    return text?.length > 13 ? text?.slice(0, 13) + "..." : text;
  };
  const handleRemoveTags = (item, value) => {
    if (value == 1) {
      let data = keywordSelectedOne.filter(
        (keyword) => keyword.toLowerCase() !== item.toLowerCase(),
      );
      setKeywordSelectedOne(data);
      if (!data?.length) {
        getNews(feedBoxOne?.boxData, "date", "word");
      }
    } else if (value === 2) {
      let data = keywordSelectedTwo.filter(
        (keyword) => keyword.toLowerCase() !== item.toLowerCase(),
      );
      setKeywordSelectedTwo(data);
      if (!data?.length) {
        getNews(feedBoxTwo?.boxData, "date", "word");
      }
    } else if (value === 3) {
      let data = keywordSelectedThree.filter(
        (keyword) => keyword.toLowerCase() !== item.toLowerCase(),
      );
      setKeywordSelectedThree(data);
      if (!data?.length) {
        getNews(feedBoxThree?.boxData, "date", "word");
      }
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
        <>
          <div className="ci-outer-mobile">
            <p className="CI-hd">Competitive Intelligence</p>
            <p className="CI-content">
              Stay informed by incorporating competitive intelligence article
              feeds for organizations and prospects that are currently being
              tracked. Additionally, add news & events from key competitor
              states that are specifically relevant to Orbit’s operations and
              objectives.
            </p>
            <div>
              <p className="CI-adding-content">
                Select the + below to start adding content.
                {/* Select ‘+’ below to begin adding content */}
              </p>
              <p className="CI-adding-content-tab">
                Click below to start adding content.
              </p>
            </div>
          </div>
          {openCompetitiveSlideTab ? (
            <div className="p-2">
              <div
                onClick={() => setOpenCompetitiveSlide(false)}
                className="heading-of-tab-ci"
              >
                <ClearIcon
                  onClick={() => {
                    setOpenCompetitiveSlideTab(false);
                    setOpenCompetitiveSlideTabTwo(false);
                    setOpenCompetitiveSlideTabThree(false);
                    setKeywordSelectedOne([]);
                    setKeywordSelectedTwo([]);
                    setKeywordSelectedThree([]);
                  }}
                />
              </div>

              <div
                className="CI-cards-content col"
                style={{ marginBottom: "92px" }}
              >
                <div className="adding-content">
                  <div className="two-head-comp">
                    <div className="result-tags-icon-comp">
                      <div className="checkbox-result-tag-comp">
                        <p className="result-comp">
                          {feedBoxOne?.data?.length} Results
                        </p>
                      </div>

                      <div>
                        <Tooltip
                          title={
                            feedBoxOne?.boxData?.org_id
                              ? feedBoxOne.boxData.org_name
                              : feedBoxOne?.boxData?.first_name &&
                                  feedBoxOne?.boxData?.last_name
                                ? `${
                                    feedBoxOne.boxData.first_name === "jp"
                                      ? "JP"
                                      : feedBoxOne.boxData.first_name
                                  } ${
                                    feedBoxOne.boxData.last_name === "nauseef"
                                      ? "Nauseef"
                                      : feedBoxOne.boxData.last_name
                                  }`
                                : feedBoxOne?.boxData?.location
                                  ? feedBoxOne?.boxData?.location
                                  : feedBoxOne?.boxData?.tags
                                    ? feedBoxOne?.boxData?.tags
                                    : feedBoxOne?.boxData?.industry
                                      ? feedBoxOne?.boxData?.industry
                                      : feedBoxOne?.boxData?.request_id
                                        ? allCustomSearchList?.find(
                                            (i) =>
                                              i?.request_id ===
                                              feedBoxOne?.boxData?.request_id,
                                          )?.custom_query_name
                                        : null
                          }
                          arrow
                          placement="top"
                        >
                          <p className="card-heading-top">
                            {feedBoxOne?.boxData?.org_id
                              ? truncateText(feedBoxOne.boxData.org_name)
                              : feedBoxOne?.boxData?.first_name &&
                                  feedBoxOne?.boxData?.last_name
                                ? truncateText(
                                    `${
                                      feedBoxOne.boxData.first_name === "jp"
                                        ? "JP"
                                        : feedBoxOne.boxData.first_name
                                    } ${feedBoxOne.boxData.last_name}`,
                                  )
                                : feedBoxOne?.boxData?.location
                                  ? truncateText(feedBoxOne?.boxData?.location)
                                  : feedBoxOne?.boxData?.tags
                                    ? truncateText(feedBoxOne?.boxData?.tags)
                                    : feedBoxOne?.boxData?.industry
                                      ? truncateText(
                                          feedBoxOne?.boxData?.industry,
                                        )
                                      : feedBoxOne?.boxData?.request_id
                                        ? truncateText(
                                            allCustomSearchList?.find(
                                              (i) =>
                                                i?.request_id ===
                                                feedBoxOne?.boxData?.request_id,
                                            )?.custom_query_name,
                                          )
                                        : null}
                          </p>
                        </Tooltip>
                      </div>

                      <div className="copy-threedot-comp">
                        <img src={print} alt="" onClick={HandlePrintOne} />
                        <img
                          src={download}
                          alt=""
                          onClick={() => handleToPDF(1)}
                        />
                        <CloseIcon
                          className="threedot-icon-comp"
                          onClick={() => handleRemoveFeed(feedBoxOne?.boxData)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="result-date-icon-comp">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <button
                          className="keyword-filter-btn"
                          disabled={searchOneApi}
                          onClick={() => setKeywordAddModalOne(true)}
                        >
                          Keyword Filter <ArrowDropDownIcon />
                        </button>
                        {keywordAddModalOne === true ? (
                          <KeywordFilterModal
                            setKeywordAddModal={setKeywordAddModalOne}
                            dataList={keywordListOne}
                            setFeedBox={setKeywordSelectedOne}
                            feedBox={keywordSelectedOne}
                          />
                        ) : null}
                      </div>
                      <div className="search_news_container">
                        <div
                          className={
                            openSearchOne
                              ? "wrap-search-news active"
                              : "wrap-search-news"
                          }
                        >
                          <input
                            type="text"
                            className={
                              openSearchOne
                                ? "input_search_news active"
                                : "input_search_news"
                            }
                            placeholder="Search..."
                            value={saveSearchOne}
                            onChange={(e) => setSaveSearchOne(e?.target?.value)}
                            // autoFocus
                          />
                          {openSearchOne ? (
                            <CloseIcon
                              className="threedot-icon-comp"
                              onClick={() => {
                                setOpenSearchOne(false);
                                setSearchOneApi(false);
                                setSaveSearchOne("");
                                getNews(feedBoxOne?.boxData, "date");
                              }}
                            />
                          ) : (
                            <img
                              src={search}
                              alt=""
                              onClick={() => {
                                setOpenSearchOne(true);
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="checkbox-result-tag-comp">
                      <img src={halflines} alt="" />
                      <p className="sorted-by-comp">Sorted by date:</p>
                      <FormControl
                        sx={{ m: 1, minWidth: 120 }}
                        className="date-comp-dropdown"
                      >
                        <Select
                          className="date-comp-select"
                          value={dateOrderOne}
                          onChange={handleChangeFeedBoxOne}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="asc" className="date-comp-menuitem">
                            <em className="date-comp-em">Ascending</em>
                          </MenuItem>
                          <MenuItem value="desc" className="date-comp-menuitem">
                            <em className="date-comp-em">Descending</em>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div ref={boxOneRef}>
                    {feedBoxOne.data?.length ? (
                      <>
                        {keywordSelectedOne?.length ? (
                          <div className="display-kw-ci">
                            {keywordSelectedOne?.map((item) => (
                              <div className="crie_selected_names">
                                {item}{" "}
                                <CloseOutlined
                                  onClick={() => handleRemoveTags(item, 1)}
                                />
                              </div>
                            ))}
                          </div>
                        ) : null}
                        {feedBoxOne.data.map((articleData, index) => (
                          <div
                            key={index}
                            className="rest-cont"
                            style={{ pageBreakInside: "avoid" }}
                          >
                            <div className="orbit-circle-text-comp">
                              <div className="jo-icon-comp">
                                <p>
                                  {feedBoxOne?.boxData?.org_id
                                    ? initialData(feedBoxOne.boxData.org_name)
                                    : feedBoxOne?.boxData?.first_name ||
                                        feedBoxOne?.boxData?.last_name
                                      ? initialData(
                                          `${
                                            feedBoxOne.boxData.first_name || ""
                                          } ${
                                            feedBoxOne.boxData.last_name || ""
                                          }`.trim(),
                                        )
                                      : feedBoxOne?.boxData?.location
                                        ? initialData(
                                            feedBoxOne?.boxData?.location,
                                          )
                                        : feedBoxOne?.boxData?.tags
                                          ? initialData(
                                              feedBoxOne?.boxData?.tags,
                                            )
                                          : feedBoxOne?.boxData?.industry
                                            ? initialData(
                                                feedBoxOne?.boxData?.industry,
                                              )
                                            : feedBoxOne?.boxData?.request_id
                                              ? initialData(
                                                  allCustomSearchList?.find(
                                                    (i) =>
                                                      i?.request_id ===
                                                      feedBoxOne?.boxData
                                                        ?.request_id,
                                                  )?.custom_query_name,
                                                )
                                              : null}
                                </p>
                              </div>
                              <div className="updated-cont">
                                <div>
                                  <p className="orbit-name-comp">
                                    {articleData?.article?.title
                                      ? articleData?.article?.title.length > 25
                                        ? `${articleData?.article?.title.slice(
                                            0,
                                            25,
                                          )}...`
                                        : articleData?.article?.title
                                      : articleData?.title}
                                  </p>
                                </div>
                                <div className="both-news-time-comp">
                                  <p className="news-comp">
                                    <a
                                      href={
                                        articleData?.article?.url
                                          ? articleData?.article?.url
                                          : articleData?.public_text_link
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {articleData?.article?.url
                                        ? articleData.article.url.split(
                                            "https://",
                                          )[1]?.length > 15
                                          ? articleData.article.url
                                              .split("https://")[1]
                                              .slice(0, 15) + "..."
                                          : articleData.article.url.split(
                                              "https://",
                                            )[1]
                                        : articleData?.public_text_link.split(
                                              "http://",
                                            )[1]?.length > 15
                                          ? articleData?.public_text_link
                                              .split("http://")[1]
                                              .slice(0, 15) + "..."
                                          : articleData?.public_text_link.split(
                                              "http://",
                                            )[1]}
                                    </a>
                                    |
                                  </p>
                                  <p className="today-comp">
                                    {new Date(
                                      articleData?.article?.date
                                        ? articleData?.article?.date
                                        : articleData?.inserted_date,
                                    ).toLocaleDateString("en-US", {
                                      month: "long",
                                      day: "numeric",
                                      year: "numeric",
                                    })}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="content-pera-comp">
                              <p className="bold-content-pera-comp">
                                {expandedSummaryOne[index] ? (
                                  <>
                                    {articleData.summary}
                                    {articleData.summary.length > 170 && (
                                      <span
                                        onClick={() => toggleSummaryOne(index)}
                                        className="see-more-btn"
                                        style={{
                                          color: "#001A54",
                                          cursor: "pointer",
                                          textDecoration: "none",
                                          paddingLeft: "5px",
                                        }}
                                      >
                                        Show Less
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {articleData.summary.length > 170
                                      ? `${articleData.summary.slice(
                                          0,
                                          articleData.summary.lastIndexOf(
                                            " ",
                                            170,
                                          ),
                                        )}`
                                      : articleData.summary}
                                    {articleData.summary.length > 170 && (
                                      <span
                                        onClick={() => toggleSummaryOne(index)}
                                        className="see-more-btn"
                                        style={{
                                          color: "#001A54",
                                          cursor: "pointer",
                                          textDecoration: "none",
                                          paddingLeft: "5px",
                                        }}
                                      >
                                        See More
                                      </span>
                                    )}
                                  </>
                                )}
                              </p>
                              <div className="Intersect-jb-nf-comp">
                                {articleData?.tags?.map((tag, idx) => (
                                  <p key={idx}>
                                    {typeof tag === "string" ? tag : tag.tag}
                                  </p>
                                ))}
                              </div>
                            </div>
                            <hr className="hr-tag-ci" />
                          </div>
                        ))}
                      </>
                    ) : (
                      <p className="text-center-result">No results found</p>
                    )}
                  </div>
                </div>
                {loadOne ? (
                  <div className="dash-cancel-save-btns">
                    <Button
                      className="de_next"
                      onClick={() => setSkipOne((skip) => skip + 10)}
                    >
                      Load More
                    </Button>
                  </div>
                ) : null}
              </div>
            </div>
          ) : openCompetitiveSlideTabTwo ? (
            <div className="p-2">
              <div
                onClick={() => setOpenCompetitiveSlideTabTwo(false)}
                className="heading-of-tab-ci"
              >
                <ClearIcon
                  onClick={() => {
                    setOpenCompetitiveSlideTabTwo(false);
                    setKeywordSelectedTwo([]);
                  }}
                />
              </div>

              <div
                className="CI-cards-content col"
                style={{ marginBottom: "92px" }}
              >
                <div className="adding-content">
                  <div className="two-head-comp">
                    <div className="result-tags-icon-comp">
                      <div className="checkbox-result-tag-comp">
                        <p className="result-comp">
                          {feedBoxTwo?.data?.length} Results
                        </p>
                      </div>

                      <div>
                        <Tooltip
                          title={
                            feedBoxTwo?.boxData?.org_id
                              ? feedBoxTwo.boxData.org_name
                              : feedBoxTwo?.boxData?.first_name &&
                                  feedBoxTwo?.boxData?.last_name
                                ? `${
                                    feedBoxTwo.boxData.first_name === "jp"
                                      ? "JP"
                                      : feedBoxTwo.boxData.first_name
                                  } ${
                                    feedBoxTwo.boxData.last_name === "nauseef"
                                      ? "Nauseef"
                                      : feedBoxTwo.boxData.last_name
                                  }`
                                : feedBoxTwo?.boxData?.location
                                  ? feedBoxTwo?.boxData?.location
                                  : feedBoxTwo?.boxData?.tags
                                    ? feedBoxTwo?.boxData?.tags
                                    : feedBoxTwo?.boxData?.industry
                                      ? feedBoxTwo?.boxData?.industry
                                      : feedBoxTwo?.boxData?.request_id
                                        ? allCustomSearchList?.find(
                                            (i) =>
                                              i?.request_id ===
                                              feedBoxTwo?.boxData?.request_id,
                                          )?.custom_query_name
                                        : null
                          }
                          arrow
                          placement="top"
                        >
                          <p className="card-heading-top">
                            {feedBoxTwo?.boxData?.org_id
                              ? truncateText(feedBoxTwo.boxData.org_name)
                              : feedBoxTwo?.boxData?.first_name &&
                                  feedBoxTwo?.boxData?.last_name
                                ? truncateText(
                                    `${
                                      feedBoxTwo.boxData.first_name === "jp"
                                        ? "JP"
                                        : feedBoxTwo.boxData.first_name
                                    } ${feedBoxTwo.boxData.last_name}`,
                                  )
                                : feedBoxTwo?.boxData?.location
                                  ? truncateText(feedBoxTwo?.boxData?.location)
                                  : feedBoxTwo?.boxData?.tags
                                    ? truncateText(feedBoxTwo?.boxData?.tags)
                                    : feedBoxTwo?.boxData?.industry
                                      ? truncateText(
                                          feedBoxTwo?.boxData?.industry,
                                        )
                                      : feedBoxTwo?.boxData?.request_id
                                        ? truncateText(
                                            allCustomSearchList?.find(
                                              (i) =>
                                                i?.request_id ===
                                                feedBoxTwo?.boxData?.request_id,
                                            )?.custom_query_name,
                                          )
                                        : null}
                          </p>
                        </Tooltip>
                      </div>

                      <div className="copy-threedot-comp">
                        <img src={print} alt="" onClick={HandlePrintOne} />
                        <img
                          src={download}
                          alt=""
                          onClick={() => handleToPDF(1)}
                        />
                        <CloseIcon
                          className="threedot-icon-comp"
                          onClick={() => handleRemoveFeed(feedBoxTwo?.boxData)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="result-date-icon-comp">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <button
                          className="keyword-filter-btn"
                          disabled={searchTwoApi}
                          onClick={() => setKeywordAddModalTwo(true)}
                        >
                          Keyword Filter <ArrowDropDownIcon />
                        </button>
                        {keywordAddModalTwo === true ? (
                          <KeywordFilterModal
                            setKeywordAddModal={setKeywordAddModalTwo}
                            dataList={keywordListTwo}
                            setFeedBox={setKeywordSelectedTwo}
                            feedBox={keywordSelectedTwo}
                          />
                        ) : null}
                      </div>
                      <div className="search_news_container">
                        <div
                          className={
                            openSearchTwo
                              ? "wrap-search-news active"
                              : "wrap-search-news"
                          }
                        >
                          <input
                            type="text"
                            className={
                              openSearchTwo
                                ? "input_search_news active"
                                : "input_search_news"
                            }
                            placeholder="Search..."
                            value={saveSearchTwo}
                            onChange={(e) => setSaveSearchTwo(e?.target?.value)}
                            // autoFocus
                          />
                          {openSearchTwo ? (
                            <CloseIcon
                              className="threedot-icon-comp"
                              onClick={() => {
                                setOpenSearchTwo(false);
                                setSearchTwoApi(false);
                                setSaveSearchTwo("");
                                getNews(feedBoxTwo?.boxData, "date");
                              }}
                            />
                          ) : (
                            <img
                              src={search}
                              alt=""
                              onClick={() => {
                                setOpenSearchTwo(true);
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="checkbox-result-tag-comp">
                      <img src={halflines} alt="" />
                      <p className="sorted-by-comp">Sorted by date:</p>
                      <FormControl
                        sx={{ m: 1, minWidth: 120 }}
                        className="date-comp-dropdown"
                      >
                        <Select
                          className="date-comp-select"
                          value={dateOrderTwo}
                          onChange={handleChangeFeedBoxTwo}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="asc" className="date-comp-menuitem">
                            <em className="date-comp-em">Ascending</em>
                          </MenuItem>
                          <MenuItem value="desc" className="date-comp-menuitem">
                            <em className="date-comp-em">Descending</em>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div ref={boxTwoRef}>
                    {feedBoxTwo?.data?.length ? (
                      <>
                        {keywordSelectedTwo?.length ? (
                          <div className="display-kw-ci">
                            {keywordSelectedTwo?.map((item) => (
                              <div className="crie_selected_names">
                                {item}{" "}
                                <CloseOutlined
                                  onClick={() => handleRemoveTags(item, 2)}
                                />
                              </div>
                            ))}
                          </div>
                        ) : null}
                        {feedBoxTwo.data.map((articleData, index) => (
                          <div
                            key={index}
                            className="rest-cont"
                            style={{ pageBreakInside: "avoid" }}
                          >
                            <div className="orbit-circle-text-comp">
                              <div className="jo-icon-comp">
                                <p>
                                  {feedBoxTwo?.boxData?.org_id
                                    ? initialData(feedBoxTwo.boxData.org_name)
                                    : feedBoxTwo?.boxData?.first_name ||
                                        feedBoxTwo?.boxData?.last_name
                                      ? initialData(
                                          `${
                                            feedBoxTwo.boxData.first_name || ""
                                          } ${
                                            feedBoxTwo.boxData.last_name || ""
                                          }`.trim(),
                                        )
                                      : feedBoxTwo?.boxData?.location
                                        ? initialData(
                                            feedBoxTwo?.boxData?.location,
                                          )
                                        : feedBoxTwo?.boxData?.tags
                                          ? initialData(
                                              feedBoxTwo?.boxData?.tags,
                                            )
                                          : feedBoxTwo?.boxData?.industry
                                            ? initialData(
                                                feedBoxTwo?.boxData?.industry,
                                              )
                                            : feedBoxTwo?.boxData?.request_id
                                              ? initialData(
                                                  allCustomSearchList?.find(
                                                    (i) =>
                                                      i?.request_id ===
                                                      feedBoxTwo?.boxData
                                                        ?.request_id,
                                                  )?.custom_query_name,
                                                )
                                              : null}
                                </p>
                              </div>
                              <div className="updated-cont">
                                <div>
                                  <p className="orbit-name-comp">
                                    {articleData?.article?.title
                                      ? articleData?.article?.title.length > 25
                                        ? `${articleData?.article?.title.slice(
                                            0,
                                            25,
                                          )}...`
                                        : articleData?.article?.title
                                      : articleData?.title}
                                  </p>
                                </div>
                                <div className="both-news-time-comp">
                                  <p className="news-comp">
                                    <a
                                      href={
                                        articleData?.article?.url
                                          ? articleData?.article?.url
                                          : articleData?.public_text_link
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {articleData?.article?.url
                                        ? articleData.article.url.split(
                                            "https://",
                                          )[1]?.length > 15
                                          ? articleData.article.url
                                              .split("https://")[1]
                                              .slice(0, 15) + "..."
                                          : articleData.article.url.split(
                                              "https://",
                                            )[1]
                                        : articleData?.public_text_link.split(
                                              "http://",
                                            )[1]?.length > 15
                                          ? articleData?.public_text_link
                                              .split("http://")[1]
                                              .slice(0, 15) + "..."
                                          : articleData?.public_text_link.split(
                                              "http://",
                                            )[1]}
                                    </a>
                                    |
                                  </p>
                                  <p className="today-comp">
                                    {new Date(
                                      articleData?.article?.date
                                        ? articleData?.article?.date
                                        : articleData?.inserted_date,
                                    ).toLocaleDateString("en-US", {
                                      month: "long",
                                      day: "numeric",
                                      year: "numeric",
                                    })}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="content-pera-comp">
                              <p className="bold-content-pera-comp">
                                {expandedSummaryTwo[index] ? (
                                  <>
                                    {articleData.summary}
                                    {articleData.summary.length > 170 && (
                                      <span
                                        onClick={() => toggleSummaryTwo(index)}
                                        className="see-more-btn"
                                        style={{
                                          color: "#001A54",
                                          cursor: "pointer",
                                          textDecoration: "none",
                                          paddingLeft: "5px",
                                        }}
                                      >
                                        Show Less
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {articleData.summary.length > 170
                                      ? `${articleData.summary.slice(
                                          0,
                                          articleData.summary.lastIndexOf(
                                            " ",
                                            170,
                                          ),
                                        )}`
                                      : articleData.summary}
                                    {articleData.summary.length > 170 && (
                                      <span
                                        onClick={() => toggleSummaryTwo(index)}
                                        className="see-more-btn"
                                        style={{
                                          color: "#001A54",
                                          cursor: "pointer",
                                          textDecoration: "none",
                                          paddingLeft: "5px",
                                        }}
                                      >
                                        See More
                                      </span>
                                    )}
                                  </>
                                )}
                              </p>
                              <div className="Intersect-jb-nf-comp">
                                {articleData?.tags?.map((tag, idx) => (
                                  <p key={idx}>
                                    {typeof tag === "string" ? tag : tag.tag}
                                  </p>
                                ))}
                              </div>
                            </div>
                            <hr className="hr-tag-ci" />
                          </div>
                        ))}
                      </>
                    ) : (
                      <p className="text-center-result">No results found</p>
                    )}
                  </div>
                </div>
                {loadTwo ? (
                  <div className="dash-cancel-save-btns">
                    <Button
                      className="de_next"
                      onClick={() => setSkipTwo((skip) => skip + 10)}
                    >
                      Load More
                    </Button>
                  </div>
                ) : null}
              </div>
            </div>
          ) : openCompetitiveSlideTabThree ? (
            <div className="p-2">
              <div
                onClick={() => setOpenCompetitiveSlideTabThree(false)}
                className="heading-of-tab-ci"
              >
                <ClearIcon
                  onClick={() => {
                    setOpenCompetitiveSlideTabThree(false);
                    setKeywordSelectedThree([]);
                  }}
                />
              </div>

              <div
                className="CI-cards-content col"
                style={{ marginBottom: "92px" }}
              >
                <div className="adding-content">
                  <div className="two-head-comp">
                    <div className="result-tags-icon-comp">
                      <div className="checkbox-result-tag-comp">
                        <p className="result-comp">
                          {feedBoxThree?.data?.length} Results
                        </p>
                      </div>

                      <div>
                        <Tooltip
                          title={
                            feedBoxThree?.boxData?.org_id
                              ? feedBoxThree.boxData.org_name
                              : feedBoxThree?.boxData?.first_name &&
                                  feedBoxThree?.boxData?.last_name
                                ? `${
                                    feedBoxThree.boxData.first_name === "jp"
                                      ? "JP"
                                      : feedBoxThree.boxData.first_name
                                  } ${
                                    feedBoxThree.boxData.last_name === "nauseef"
                                      ? "Nauseef"
                                      : feedBoxThree.boxData.last_name
                                  }`
                                : feedBoxThree?.boxData?.location
                                  ? feedBoxThree?.boxData?.location
                                  : feedBoxThree?.boxData?.tags
                                    ? feedBoxThree?.boxData?.tags
                                    : feedBoxThree?.boxData?.industry
                                      ? feedBoxThree?.boxData?.industry
                                      : feedBoxThree?.boxData?.request_id
                                        ? allCustomSearchList?.find(
                                            (i) =>
                                              i?.request_id ===
                                              feedBoxThree?.boxData?.request_id,
                                          )?.custom_query_name
                                        : null
                          }
                          arrow
                          placement="top"
                        >
                          <p className="card-heading-top">
                            {feedBoxThree?.boxData?.org_id
                              ? truncateText(feedBoxThree.boxData.org_name)
                              : feedBoxThree?.boxData?.first_name &&
                                  feedBoxThree?.boxData?.last_name
                                ? truncateText(
                                    `${
                                      feedBoxThree.boxData.first_name === "jp"
                                        ? "JP"
                                        : feedBoxThree.boxData.first_name
                                    } ${feedBoxThree.boxData.last_name}`,
                                  )
                                : feedBoxThree?.boxData?.location
                                  ? truncateText(
                                      feedBoxThree?.boxData?.location,
                                    )
                                  : feedBoxThree?.boxData?.tags
                                    ? truncateText(feedBoxThree?.boxData?.tags)
                                    : feedBoxThree?.boxData?.industry
                                      ? truncateText(
                                          feedBoxThree?.boxData?.industry,
                                        )
                                      : feedBoxThree?.boxData?.request_id
                                        ? truncateText(
                                            allCustomSearchList?.find(
                                              (i) =>
                                                i?.request_id ===
                                                feedBoxThree?.boxData
                                                  ?.request_id,
                                            )?.custom_query_name,
                                          )
                                        : null}
                          </p>
                        </Tooltip>
                      </div>

                      <div className="copy-threedot-comp">
                        <img src={print} alt="" onClick={HandlePrintOne} />
                        <img
                          src={download}
                          alt=""
                          onClick={() => handleToPDF(1)}
                        />
                        <CloseIcon
                          className="threedot-icon-comp"
                          onClick={() =>
                            handleRemoveFeed(feedBoxThree?.boxData)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="result-date-icon-comp">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <button
                          className="keyword-filter-btn"
                          disabled={searchThreeApi}
                          onClick={() => setKeywordAddModalThree(true)}
                        >
                          Keyword Filter <ArrowDropDownIcon />
                        </button>
                        {keywordAddModalThree === true ? (
                          <KeywordFilterModal
                            setKeywordAddModal={setKeywordAddModalThree}
                            dataList={keywordListThree}
                            setFeedBox={setKeywordSelectedThree}
                            feedBox={keywordSelectedThree}
                          />
                        ) : null}
                      </div>
                      <div className="search_news_container">
                        <div
                          className={
                            openSearchThree
                              ? "wrap-search-news active"
                              : "wrap-search-news"
                          }
                        >
                          <input
                            type="text"
                            className={
                              openSearchThree
                                ? "input_search_news active"
                                : "input_search_news"
                            }
                            placeholder="Search..."
                            value={saveSearchThree}
                            onChange={(e) =>
                              setSaveSearchThree(e?.target?.value)
                            }
                            // autoFocus
                          />
                          {openSearchThree ? (
                            <CloseIcon
                              className="threedot-icon-comp"
                              onClick={() => {
                                setOpenSearchThree(false);
                                setSearchThreeApi(false);
                                setSaveSearchThree("");
                                getNews(feedBoxThree?.boxData, "date");
                              }}
                            />
                          ) : (
                            <img
                              src={search}
                              alt=""
                              onClick={() => {
                                setOpenSearchThree(true);
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="checkbox-result-tag-comp">
                      <img src={halflines} alt="" />
                      <p className="sorted-by-comp">Sorted by date:</p>
                      <FormControl
                        sx={{ m: 1, minWidth: 120 }}
                        className="date-comp-dropdown"
                      >
                        <Select
                          className="date-comp-select"
                          value={dateOrderThree}
                          onChange={handleChangeFeedBoxThree}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="asc" className="date-comp-menuitem">
                            <em className="date-comp-em">Ascending</em>
                          </MenuItem>
                          <MenuItem value="desc" className="date-comp-menuitem">
                            <em className="date-comp-em">Descending</em>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div ref={boxThreeRef}>
                    {feedBoxThree?.data?.length ? (
                      <>
                        {keywordSelectedThree?.length ? (
                          <div className="display-kw-ci">
                            {keywordSelectedThree?.map((item) => (
                              <div className="crie_selected_names">
                                {item}{" "}
                                <CloseOutlined
                                  onClick={() => handleRemoveTags(item, 3)}
                                />
                              </div>
                            ))}
                          </div>
                        ) : null}
                        {feedBoxThree.data.map((articleData, index) => (
                          <div
                            key={index}
                            className="rest-cont"
                            style={{ pageBreakInside: "avoid" }}
                          >
                            <div className="orbit-circle-text-comp">
                              <div className="jo-icon-comp">
                                <p>
                                  {feedBoxThree?.boxData?.org_id
                                    ? initialData(feedBoxThree.boxData.org_name)
                                    : feedBoxThree?.boxData?.first_name ||
                                        feedBoxThree?.boxData?.last_name
                                      ? initialData(
                                          `${
                                            feedBoxThree.boxData.first_name || ""
                                          } ${
                                            feedBoxThree.boxData.last_name || ""
                                          }`.trim(),
                                        )
                                      : feedBoxThree?.boxData?.location
                                        ? initialData(
                                            feedBoxThree?.boxData?.location,
                                          )
                                        : feedBoxThree?.boxData?.tags
                                          ? initialData(
                                              feedBoxThree?.boxData?.tags,
                                            )
                                          : feedBoxThree?.boxData?.industry
                                            ? initialData(
                                                feedBoxThree?.boxData?.industry,
                                              )
                                            : feedBoxThree?.boxData?.request_id
                                              ? initialData(
                                                  allCustomSearchList?.find(
                                                    (i) =>
                                                      i?.request_id ===
                                                      feedBoxThree?.boxData
                                                        ?.request_id,
                                                  )?.custom_query_name,
                                                )
                                              : null}
                                </p>
                              </div>

                              <div className="updated-cont">
                                <div>
                                  <p className="orbit-name-comp">
                                    {articleData?.article?.title
                                      ? articleData?.article?.title.length > 25
                                        ? `${articleData?.article?.title.slice(
                                            0,
                                            25,
                                          )}...`
                                        : articleData?.article?.title
                                      : articleData?.title}
                                  </p>
                                </div>
                                <div className="both-news-time-comp">
                                  <p className="news-comp">
                                    <a
                                      href={
                                        articleData?.article?.url
                                          ? articleData?.article?.url
                                          : articleData?.public_text_link
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {articleData?.article?.url
                                        ? articleData.article.url.split(
                                            "https://",
                                          )[1]?.length > 15
                                          ? articleData.article.url
                                              .split("https://")[1]
                                              .slice(0, 15) + "..."
                                          : articleData.article.url.split(
                                              "https://",
                                            )[1]
                                        : articleData?.public_text_link.split(
                                              "http://",
                                            )[1]?.length > 15
                                          ? articleData?.public_text_link
                                              .split("http://")[1]
                                              .slice(0, 15) + "..."
                                          : articleData?.public_text_link.split(
                                              "http://",
                                            )[1]}
                                    </a>
                                    |
                                  </p>
                                  <p className="today-comp">
                                    {new Date(
                                      articleData?.article?.date
                                        ? articleData?.article?.date
                                        : articleData?.inserted_date,
                                    ).toLocaleDateString("en-US", {
                                      month: "long",
                                      day: "numeric",
                                      year: "numeric",
                                    })}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="content-pera-comp">
                              <p className="bold-content-pera-comp">
                                {expandedSummaryThree[index] ? (
                                  <>
                                    {articleData.summary}
                                    {articleData.summary.length > 170 && (
                                      <span
                                        onClick={() =>
                                          toggleSummaryThree(index)
                                        }
                                        className="see-more-btn"
                                        style={{
                                          color: "#001A54",
                                          cursor: "pointer",
                                          textDecoration: "none",
                                          paddingLeft: "5px",
                                        }}
                                      >
                                        Show Less
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {articleData.summary.length > 170
                                      ? `${articleData.summary.slice(
                                          0,
                                          articleData.summary.lastIndexOf(
                                            " ",
                                            170,
                                          ),
                                        )}`
                                      : articleData.summary}
                                    {articleData.summary.length > 170 && (
                                      <span
                                        onClick={() =>
                                          toggleSummaryThree(index)
                                        }
                                        className="see-more-btn"
                                        style={{
                                          color: "#001A54",
                                          cursor: "pointer",
                                          textDecoration: "none",
                                          paddingLeft: "5px",
                                        }}
                                      >
                                        See More
                                      </span>
                                    )}
                                  </>
                                )}
                              </p>
                              <div className="Intersect-jb-nf-comp">
                                {articleData?.tags?.map((tag, idx) => (
                                  <p key={idx}>
                                    {typeof tag === "string" ? tag : tag.tag}
                                  </p>
                                ))}
                              </div>
                            </div>
                            <hr className="hr-tag-ci" />
                          </div>
                        ))}
                      </>
                    ) : (
                      <p className="text-center-result">No results found</p>
                    )}
                  </div>
                </div>
                {loadThree ? (
                  <div className="dash-cancel-save-btns">
                    <Button
                      className="de_next"
                      onClick={() => setSkipThree((skip) => skip + 10)}
                    >
                      Load More
                    </Button>
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <div className="add-contents-cards row">
              {feedBoxOne?.boxData?.id ? (
                <div className="CI-cards-content col">
                  <div className="adding-content">
                    <div className="two-head-comp">
                      <div className="result-tags-icon-comp">
                        <div className="checkbox-result-tag-comp">
                          <p className="result-comp">
                            {feedBoxOne?.data?.length} Results
                          </p>
                        </div>

                        <div>
                          <Tooltip
                            title={
                              feedBoxOne?.boxData?.org_id
                                ? feedBoxOne.boxData.org_name
                                : feedBoxOne?.boxData?.first_name &&
                                    feedBoxOne?.boxData?.last_name
                                  ? `${
                                      feedBoxOne.boxData.first_name === "jp"
                                        ? "JP"
                                        : feedBoxOne.boxData.first_name
                                    } ${
                                      feedBoxOne.boxData.last_name === "nauseef"
                                        ? "Nauseef"
                                        : feedBoxOne.boxData.last_name
                                    }`
                                  : feedBoxOne?.boxData?.location
                                    ? feedBoxOne?.boxData?.location
                                    : feedBoxOne?.boxData?.tags
                                      ? feedBoxOne?.boxData?.tags
                                      : feedBoxOne?.boxData?.industry
                                        ? feedBoxOne?.boxData?.industry
                                        : feedBoxOne?.boxData?.request_id
                                          ? allCustomSearchList?.find(
                                              (i) =>
                                                i?.request_id ===
                                                feedBoxOne?.boxData?.request_id,
                                            )?.custom_query_name
                                          : null
                            }
                            arrow
                            placement="top"
                          >
                            <p className="card-heading-top">
                              {feedBoxOne?.boxData?.org_id
                                ? truncateText(feedBoxOne.boxData.org_name)
                                : feedBoxOne?.boxData?.first_name &&
                                    feedBoxOne?.boxData?.last_name
                                  ? truncateText(
                                      `${
                                        feedBoxOne.boxData.first_name === "jp"
                                          ? "JP"
                                          : feedBoxOne.boxData.first_name
                                      } ${feedBoxOne.boxData.last_name}`,
                                    )
                                  : feedBoxOne?.boxData?.location
                                    ? truncateText(
                                        feedBoxOne?.boxData?.location,
                                      )
                                    : feedBoxOne?.boxData?.tags
                                      ? truncateText(feedBoxOne?.boxData?.tags)
                                      : feedBoxOne?.boxData?.industry
                                        ? truncateText(
                                            feedBoxOne?.boxData?.industry,
                                          )
                                        : feedBoxOne?.boxData?.request_id
                                          ? truncateText(
                                              allCustomSearchList?.find(
                                                (i) =>
                                                  i?.request_id ===
                                                  feedBoxOne?.boxData
                                                    ?.request_id,
                                              )?.custom_query_name,
                                            )
                                          : null}
                            </p>
                          </Tooltip>
                        </div>

                        <div className="copy-threedot-comp">
                          <img src={print} alt="" onClick={HandlePrintOne} />
                          <img
                            src={download}
                            alt=""
                            onClick={() => handleToPDF(1)}
                          />
                          <CloseIcon
                            className="threedot-icon-comp"
                            onClick={() =>
                              handleRemoveFeed(feedBoxOne?.boxData)
                            }
                          />
                        </div>
                      </div>
                      <div className="result-date-icon-comp">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "5px",
                          }}
                        >
                          <div style={{ position: "relative" }}>
                            <button
                              className="keyword-filter-btn"
                              disabled={searchOneApi}
                              onClick={() => setKeywordAddModalOne(true)}
                            >
                              Keyword Filter <ArrowDropDownIcon />
                            </button>
                            {keywordAddModalOne === true ? (
                              <KeywordFilterModal
                                setKeywordAddModal={setKeywordAddModalOne}
                                dataList={keywordListOne}
                                setFeedBox={setKeywordSelectedOne}
                                feedBox={keywordSelectedOne}
                              />
                            ) : null}
                          </div>
                          <div className="search_news_container">
                            <div
                              className={
                                openSearchOne
                                  ? "wrap-search-news active"
                                  : "wrap-search-news"
                              }
                            >
                              <input
                                type="text"
                                className={
                                  openSearchOne
                                    ? "input_search_news active"
                                    : "input_search_news"
                                }
                                placeholder="Search..."
                                value={saveSearchOne}
                                onChange={(e) =>
                                  setSaveSearchOne(e?.target?.value)
                                }
                                // autoFocus
                              />
                              {openSearchOne ? (
                                <CloseIcon
                                  className="threedot-icon-comp"
                                  onClick={() => {
                                    setOpenSearchOne(false);
                                    setSearchOneApi(false);
                                    setSaveSearchOne("");
                                    getNews(feedBoxOne?.boxData, "date");
                                  }}
                                />
                              ) : (
                                <img
                                  src={search}
                                  alt=""
                                  onClick={() => {
                                    setOpenSearchOne(true);
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="checkbox-result-tag-comp">
                          <img src={halflines} alt="" />
                          <p className="sorted-by-comp">Sorted by date:</p>
                          <FormControl
                            sx={{ m: 1, minWidth: 120 }}
                            className="date-comp-dropdown"
                          >
                            <Select
                              className="date-comp-select"
                              value={dateOrderOne}
                              onChange={handleChangeFeedBoxOne}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem
                                value="asc"
                                className="date-comp-menuitem"
                              >
                                <em className="date-comp-em">Ascending</em>
                              </MenuItem>
                              <MenuItem
                                value="desc"
                                className="date-comp-menuitem"
                              >
                                <em className="date-comp-em">Descending</em>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <div ref={boxOneRef}>
                      {feedBoxOne.data?.length ? (
                        <>
                          {keywordSelectedOne?.length ? (
                            <div className="display-kw-ci">
                              {keywordSelectedOne?.map((item) => (
                                <div className="crie_selected_names">
                                  {item}{" "}
                                  <CloseOutlined
                                    onClick={() => handleRemoveTags(item, 1)}
                                  />
                                </div>
                              ))}
                            </div>
                          ) : null}
                          {feedBoxOne.data.map((articleData, index) => (
                            <div
                              key={index}
                              className="rest-cont"
                              style={{ pageBreakInside: "avoid" }}
                            >
                              <div className="orbit-circle-text-comp">
                                <div className="jo-icon-comp">
                                  <p>
                                    {feedBoxOne?.boxData?.org_id
                                      ? initialData(feedBoxOne.boxData.org_name)
                                      : feedBoxOne?.boxData?.first_name ||
                                          feedBoxOne?.boxData?.last_name
                                        ? initialData(
                                            `${
                                              feedBoxOne.boxData.first_name || ""
                                            } ${
                                              feedBoxOne.boxData.last_name || ""
                                            }`.trim(),
                                          )
                                        : feedBoxOne?.boxData?.location
                                          ? initialData(
                                              feedBoxOne?.boxData?.location,
                                            )
                                          : feedBoxOne?.boxData?.tags
                                            ? initialData(
                                                feedBoxOne?.boxData?.tags,
                                              )
                                            : feedBoxOne?.boxData?.industry
                                              ? initialData(
                                                  feedBoxOne?.boxData?.industry,
                                                )
                                              : feedBoxOne?.boxData?.request_id
                                                ? initialData(
                                                    allCustomSearchList?.find(
                                                      (i) =>
                                                        i?.request_id ===
                                                        feedBoxOne?.boxData
                                                          ?.request_id,
                                                    )?.custom_query_name,
                                                  )
                                                : null}
                                  </p>
                                </div>
                                <div className="updated-cont">
                                  <div>
                                    <p className="orbit-name-comp">
                                      {articleData?.article?.title
                                        ? articleData?.article?.title.length >
                                          25
                                          ? `${articleData?.article?.title.slice(
                                              0,
                                              25,
                                            )}...`
                                          : articleData?.article?.title
                                        : articleData?.title}
                                    </p>
                                  </div>
                                  <div className="both-news-time-comp">
                                    <p className="news-comp">
                                      <a
                                        href={
                                          articleData?.article?.url
                                            ? articleData?.article?.url
                                            : articleData?.public_text_link
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {articleData?.article?.url
                                          ? articleData.article.url.split(
                                              "https://",
                                            )[1]?.length > 15
                                            ? articleData.article.url
                                                .split("https://")[1]
                                                .slice(0, 15) + "..."
                                            : articleData.article.url.split(
                                                "https://",
                                              )[1]
                                          : articleData?.public_text_link.split(
                                                "http://",
                                              )[1]?.length > 15
                                            ? articleData?.public_text_link
                                                .split("http://")[1]
                                                .slice(0, 15) + "..."
                                            : articleData?.public_text_link.split(
                                                "http://",
                                              )[1]}
                                      </a>
                                      |
                                    </p>
                                    <p className="today-comp">
                                      {new Date(
                                        articleData?.article?.date
                                          ? articleData?.article?.date
                                          : articleData?.inserted_date,
                                      ).toLocaleDateString("en-US", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric",
                                      })}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="content-pera-comp">
                                <p className="bold-content-pera-comp">
                                  {expandedSummaryOne[index] ? (
                                    <>
                                      {articleData.summary}
                                      {articleData.summary.length > 170 && (
                                        <span
                                          onClick={() =>
                                            toggleSummaryOne(index)
                                          }
                                          className="see-more-btn"
                                          style={{
                                            color: "#001A54",
                                            cursor: "pointer",
                                            textDecoration: "none",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          Show Less
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {articleData.summary.length > 170
                                        ? `${articleData.summary.slice(
                                            0,
                                            articleData.summary.lastIndexOf(
                                              " ",
                                              170,
                                            ),
                                          )}`
                                        : articleData.summary}
                                      {articleData.summary.length > 170 && (
                                        <span
                                          onClick={() =>
                                            toggleSummaryOne(index)
                                          }
                                          className="see-more-btn"
                                          style={{
                                            color: "#001A54",
                                            cursor: "pointer",
                                            textDecoration: "none",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          See More
                                        </span>
                                      )}
                                    </>
                                  )}
                                </p>
                                <div className="Intersect-jb-nf-comp">
                                  {articleData?.tags?.map((tag, idx) => (
                                    <p key={idx}>
                                      {typeof tag === "string" ? tag : tag.tag}
                                    </p>
                                  ))}
                                </div>
                              </div>
                              <hr className="hr-tag-ci" />
                            </div>
                          ))}
                        </>
                      ) : (
                        <p className="text-center-result">No results found</p>
                      )}
                    </div>
                  </div>
                  {loadOne ? (
                    <div className="dash-cancel-save-btns">
                      <Button
                        className="de_next"
                        onClick={() => setSkipOne((skip) => skip + 10)}
                      >
                        Load More
                      </Button>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div
                  className="CI-cards col"
                  onClick={() => {
                    handleOpen(1);
                  }}
                >
                  <AddCircleIcon className="add-content-button" />
                  <p className="CI-card-content">Add Content</p>
                </div>
              )}
              {/* Feed box one end here  */}
              {feedBoxTwo?.boxData?.id ? (
                <div className="CI-cards-content col">
                  <div className="adding-content">
                    <div className="two-head-comp">
                      <div className="result-tags-icon-comp">
                        <div className="checkbox-result-tag-comp">
                          <p className="result-comp">
                            {feedBoxTwo?.data?.length} Results
                          </p>
                        </div>
                        <div>
                          <Tooltip
                            title={
                              feedBoxTwo?.boxData?.org_id
                                ? feedBoxTwo.boxData.org_name
                                : feedBoxTwo?.boxData?.first_name &&
                                    feedBoxTwo?.boxData?.last_name
                                  ? `${
                                      feedBoxTwo.boxData.first_name === "jp"
                                        ? "JP"
                                        : feedBoxTwo.boxData.first_name
                                    } ${
                                      feedBoxTwo.boxData.last_name === "nauseef"
                                        ? "Nauseef"
                                        : feedBoxTwo.boxData.last_name
                                    }`
                                  : feedBoxTwo?.boxData?.location
                                    ? feedBoxTwo?.boxData?.location
                                    : feedBoxTwo?.boxData?.tags
                                      ? feedBoxTwo?.boxData?.tags
                                      : feedBoxTwo?.boxData?.industry
                                        ? feedBoxTwo?.boxData?.industry
                                        : feedBoxTwo?.boxData?.request_id
                                          ? allCustomSearchList?.find(
                                              (i) =>
                                                i?.request_id ===
                                                feedBoxTwo?.boxData?.request_id,
                                            )?.custom_query_name
                                          : null
                            }
                            arrow
                            placement="top"
                          >
                            <p className="card-heading-top">
                              {feedBoxTwo?.boxData?.org_id
                                ? truncateText(feedBoxTwo.boxData.org_name)
                                : feedBoxTwo?.boxData?.first_name &&
                                    feedBoxTwo?.boxData?.last_name
                                  ? truncateText(
                                      `${
                                        feedBoxTwo.boxData.first_name === "jp"
                                          ? "JP"
                                          : feedBoxTwo.boxData.first_name
                                      } ${feedBoxTwo.boxData.last_name}`,
                                    )
                                  : feedBoxTwo?.boxData?.location
                                    ? truncateText(
                                        feedBoxTwo?.boxData?.location,
                                      )
                                    : feedBoxTwo?.boxData?.tags
                                      ? truncateText(feedBoxTwo?.boxData?.tags)
                                      : feedBoxTwo?.boxData?.industry
                                        ? truncateText(
                                            feedBoxTwo?.boxData?.industry,
                                          )
                                        : feedBoxTwo?.boxData?.request_id
                                          ? truncateText(
                                              allCustomSearchList?.find(
                                                (i) =>
                                                  i?.request_id ===
                                                  feedBoxTwo?.boxData
                                                    ?.request_id,
                                              )?.custom_query_name,
                                            )
                                          : null}
                            </p>
                          </Tooltip>
                        </div>
                        <div className="copy-threedot-comp">
                          <img src={print} alt="" onClick={HandlePrintTwo} />
                          <img
                            src={download}
                            alt=""
                            onClick={() => handleToPDF(2)}
                          />
                          <CloseIcon
                            className="threedot-icon-comp"
                            onClick={() =>
                              handleRemoveFeed(feedBoxTwo?.boxData)
                            }
                          />
                        </div>
                      </div>
                      <div className="result-date-icon-comp">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "5px",
                          }}
                        >
                          <div style={{ position: "relative" }}>
                            <button
                              className="keyword-filter-btn"
                              disabled={searchTwoApi}
                              onClick={() => setKeywordAddModalTwo(true)}
                            >
                              Keyword Filter <ArrowDropDownIcon />
                            </button>
                            {keywordAddModalTwo === true ? (
                              <KeywordFilterModal
                                setKeywordAddModal={setKeywordAddModalTwo}
                                dataList={keywordListTwo}
                                setFeedBox={setKeywordSelectedTwo}
                                feedBox={keywordSelectedTwo}
                              />
                            ) : null}
                          </div>
                          <div className="search_news_container">
                            <div
                              className={
                                openSearchTwo
                                  ? "wrap-search-news active"
                                  : "wrap-search-news"
                              }
                            >
                              <input
                                type="text"
                                className={
                                  openSearchTwo
                                    ? "input_search_news active"
                                    : "input_search_news"
                                }
                                placeholder="Search..."
                                value={saveSearchTwo}
                                onChange={(e) =>
                                  setSaveSearchTwo(e?.target?.value)
                                }
                                // autoFocus
                              />
                              {openSearchTwo ? (
                                <CloseIcon
                                  className="threedot-icon-comp"
                                  onClick={() => {
                                    setOpenSearchTwo(false);
                                    setSearchTwoApi(false);
                                    setSaveSearchTwo("");
                                    getNews(feedBoxTwo?.boxData, "date");
                                  }}
                                />
                              ) : (
                                <img
                                  src={search}
                                  alt=""
                                  onClick={() => {
                                    setOpenSearchTwo(true);
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="checkbox-result-tag-comp">
                          <img src={halflines} alt="" />
                          <p className="sorted-by-comp">Sorted by date:</p>
                          <FormControl
                            sx={{ m: 1, minWidth: 120 }}
                            className="date-comp-dropdown"
                          >
                            <Select
                              className="date-comp-select"
                              value={dateOrderTwo}
                              onChange={handleChangeFeedBoxTwo}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem
                                value="asc"
                                className="date-comp-menuitem"
                              >
                                <em className="date-comp-em">Ascending</em>
                              </MenuItem>
                              <MenuItem
                                value="desc"
                                className="date-comp-menuitem"
                              >
                                <em className="date-comp-em">Descending</em>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <div ref={boxTwoRef}>
                      {feedBoxTwo?.data?.length ? (
                        <>
                          {keywordSelectedTwo?.length ? (
                            <div className="display-kw-ci">
                              {keywordSelectedTwo?.map((item) => (
                                <div className="crie_selected_names">
                                  {item}{" "}
                                  <CloseOutlined
                                    onClick={() => handleRemoveTags(item, 2)}
                                  />
                                </div>
                              ))}
                            </div>
                          ) : null}
                          {feedBoxTwo.data.map((articleData, index) => (
                            <div
                              key={index}
                              className="rest-cont"
                              style={{ pageBreakInside: "avoid" }}
                            >
                              <div className="orbit-circle-text-comp">
                                <div className="jo-icon-comp">
                                  <p>
                                    {feedBoxTwo?.boxData?.org_id
                                      ? initialData(feedBoxTwo.boxData.org_name)
                                      : feedBoxTwo?.boxData?.first_name ||
                                          feedBoxTwo?.boxData?.last_name
                                        ? initialData(
                                            `${
                                              feedBoxTwo.boxData.first_name || ""
                                            } ${
                                              feedBoxTwo.boxData.last_name || ""
                                            }`.trim(),
                                          )
                                        : feedBoxTwo?.boxData?.location
                                          ? initialData(
                                              feedBoxTwo?.boxData?.location,
                                            )
                                          : feedBoxTwo?.boxData?.tags
                                            ? initialData(
                                                feedBoxTwo?.boxData?.tags,
                                              )
                                            : feedBoxTwo?.boxData?.industry
                                              ? initialData(
                                                  feedBoxTwo?.boxData?.industry,
                                                )
                                              : feedBoxTwo?.boxData?.request_id
                                                ? initialData(
                                                    allCustomSearchList?.find(
                                                      (i) =>
                                                        i?.request_id ===
                                                        feedBoxTwo?.boxData
                                                          ?.request_id,
                                                    )?.custom_query_name,
                                                  )
                                                : null}
                                  </p>
                                </div>
                                <div className="updated-cont">
                                  <div>
                                    <p className="orbit-name-comp">
                                      {articleData?.article?.title
                                        ? articleData?.article?.title.length >
                                          25
                                          ? `${articleData?.article?.title.slice(
                                              0,
                                              25,
                                            )}...`
                                          : articleData?.article?.title
                                        : articleData?.title}
                                    </p>
                                  </div>
                                  <div className="both-news-time-comp">
                                    <p className="news-comp">
                                      <a
                                        href={
                                          articleData?.article?.url
                                            ? articleData?.article?.url
                                            : articleData?.public_text_link
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {articleData?.article?.url
                                          ? articleData.article.url.split(
                                              "https://",
                                            )[1]?.length > 15
                                            ? articleData.article.url
                                                .split("https://")[1]
                                                .slice(0, 15) + "..."
                                            : articleData.article.url.split(
                                                "https://",
                                              )[1]
                                          : articleData?.public_text_link.split(
                                                "http://",
                                              )[1]?.length > 15
                                            ? articleData?.public_text_link
                                                .split("http://")[1]
                                                .slice(0, 15) + "..."
                                            : articleData?.public_text_link.split(
                                                "http://",
                                              )[1]}
                                      </a>
                                      |
                                    </p>
                                    <p className="today-comp">
                                      {new Date(
                                        articleData?.article?.date
                                          ? articleData?.article?.date
                                          : articleData?.inserted_date,
                                      ).toLocaleDateString("en-US", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric",
                                      })}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="content-pera-comp">
                                <p className="bold-content-pera-comp">
                                  {expandedSummaryTwo[index] ? (
                                    <>
                                      {articleData.summary}
                                      {articleData.summary.length > 170 && (
                                        <span
                                          onClick={() =>
                                            toggleSummaryTwo(index)
                                          }
                                          className="see-more-btn"
                                          style={{
                                            color: "#001A54",
                                            cursor: "pointer",
                                            textDecoration: "none",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          Show Less
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {articleData.summary.length > 170
                                        ? `${articleData.summary.slice(
                                            0,
                                            articleData.summary.lastIndexOf(
                                              " ",
                                              170,
                                            ),
                                          )}`
                                        : articleData.summary}
                                      {articleData.summary.length > 170 && (
                                        <span
                                          onClick={() =>
                                            toggleSummaryTwo(index)
                                          }
                                          className="see-more-btn"
                                          style={{
                                            color: "#001A54",
                                            cursor: "pointer",
                                            textDecoration: "none",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          See More
                                        </span>
                                      )}
                                    </>
                                  )}
                                </p>
                                <div className="Intersect-jb-nf-comp">
                                  {articleData?.tags?.map((tag, idx) => (
                                    <p key={idx}>
                                      {typeof tag === "string" ? tag : tag.tag}
                                    </p>
                                  ))}
                                </div>
                              </div>
                              <hr className="hr-tag-ci" />
                            </div>
                          ))}
                        </>
                      ) : (
                        <p className="text-center-result">No results found</p>
                      )}
                    </div>
                  </div>
                  {loadTwo ? (
                    <div className="dash-cancel-save-btns">
                      <Button
                        className="de_next"
                        onClick={() => setSkipTwo((skip) => skip + 10)}
                      >
                        Load More
                      </Button>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div
                  className="CI-cards col"
                  onClick={() => {
                    handleOpen(2);
                  }}
                >
                  <AddCircleIcon className="add-content-button" />
                  <p className="CI-card-content">Add Content</p>
                </div>
              )}
              {/* feed box 2 end here  */}
              {feedBoxThree?.boxData?.id ? (
                <div className="CI-cards-content col">
                  <div className="adding-content">
                    <div className="two-head-comp">
                      <div className="result-tags-icon-comp">
                        <div className="checkbox-result-tag-comp">
                          <p className="result-comp">
                            {feedBoxThree?.data?.length} Results
                          </p>
                        </div>
                        <div>
                          <Tooltip
                            title={
                              feedBoxThree?.boxData?.org_id
                                ? feedBoxThree.boxData.org_name
                                : feedBoxThree?.boxData?.first_name &&
                                    feedBoxThree?.boxData?.last_name
                                  ? `${
                                      feedBoxThree.boxData.first_name === "jp"
                                        ? "JP"
                                        : feedBoxThree.boxData.first_name
                                    } ${
                                      feedBoxThree.boxData.last_name ===
                                      "nauseef"
                                        ? "Nauseef"
                                        : feedBoxThree.boxData.last_name
                                    }`
                                  : feedBoxThree?.boxData?.location
                                    ? feedBoxThree?.boxData?.location
                                    : feedBoxThree?.boxData?.tags
                                      ? feedBoxThree?.boxData?.tags
                                      : feedBoxThree?.boxData?.industry
                                        ? feedBoxThree?.boxData?.industry
                                        : feedBoxThree?.boxData?.request_id
                                          ? allCustomSearchList?.find(
                                              (i) =>
                                                i?.request_id ===
                                                feedBoxThree?.boxData
                                                  ?.request_id,
                                            )?.custom_query_name
                                          : null
                            }
                            arrow
                            placement="top"
                          >
                            <p className="card-heading-top">
                              {feedBoxThree?.boxData?.org_id
                                ? truncateText(feedBoxThree.boxData.org_name)
                                : feedBoxThree?.boxData?.first_name &&
                                    feedBoxThree?.boxData?.last_name
                                  ? truncateText(
                                      `${
                                        feedBoxThree.boxData.first_name === "jp"
                                          ? "JP"
                                          : feedBoxThree.boxData.first_name
                                      } ${feedBoxThree.boxData.last_name}`,
                                    )
                                  : feedBoxThree?.boxData?.location
                                    ? truncateText(
                                        feedBoxThree?.boxData?.location,
                                      )
                                    : feedBoxThree?.boxData?.tags
                                      ? truncateText(
                                          feedBoxThree?.boxData?.tags,
                                        )
                                      : feedBoxThree?.boxData?.industry
                                        ? truncateText(
                                            feedBoxThree?.boxData?.industry,
                                          )
                                        : feedBoxThree?.boxData?.request_id
                                          ? truncateText(
                                              allCustomSearchList?.find(
                                                (i) =>
                                                  i?.request_id ===
                                                  feedBoxThree?.boxData
                                                    ?.request_id,
                                              )?.custom_query_name,
                                            )
                                          : null}
                            </p>
                          </Tooltip>
                        </div>
                        <div className="copy-threedot-comp">
                          <img src={print} alt="" onClick={HandlePrintThree} />
                          <img
                            src={download}
                            alt=""
                            onClick={() => handleToPDF(3)}
                          />
                          <CloseIcon
                            className="threedot-icon-comp"
                            onClick={() =>
                              handleRemoveFeed(feedBoxThree?.boxData)
                            }
                          />
                        </div>
                      </div>
                      <div className="result-date-icon-comp">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "5px",
                          }}
                        >
                          <div style={{ position: "relative" }}>
                            <button
                              className="keyword-filter-btn"
                              disabled={searchThreeApi}
                              onClick={() => setKeywordAddModalThree(true)}
                            >
                              Keyword Filter <ArrowDropDownIcon />
                            </button>
                            {keywordAddModalThree === true ? (
                              <KeywordFilterModal
                                setKeywordAddModal={setKeywordAddModalThree}
                                dataList={keywordListThree}
                                setFeedBox={setKeywordSelectedThree}
                                feedBox={keywordSelectedThree}
                              />
                            ) : null}
                          </div>
                          <div className="search_news_container">
                            <div
                              className={
                                openSearchThree
                                  ? "wrap-search-news active"
                                  : "wrap-search-news"
                              }
                            >
                              <input
                                type="text"
                                className={
                                  openSearchThree
                                    ? "input_search_news active"
                                    : "input_search_news"
                                }
                                placeholder="Search..."
                                value={saveSearchThree}
                                onChange={(e) =>
                                  setSaveSearchThree(e?.target?.value)
                                }
                                // autoFocus
                              />
                              {openSearchThree ? (
                                <CloseIcon
                                  className="threedot-icon-comp"
                                  onClick={() => {
                                    setOpenSearchThree(false);
                                    setSearchThreeApi(false);
                                    setSaveSearchThree("");
                                    getNews(feedBoxThree?.boxData, "date");
                                  }}
                                />
                              ) : (
                                <img
                                  src={search}
                                  alt=""
                                  onClick={() => {
                                    setOpenSearchThree(true);
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="checkbox-result-tag-comp">
                          <img src={halflines} alt="" />
                          <p className="sorted-by-comp">Sorted by date:</p>
                          <FormControl
                            sx={{ m: 1, minWidth: 120 }}
                            className="date-comp-dropdown"
                          >
                            <Select
                              className="date-comp-select"
                              value={dateOrderThree}
                              onChange={handleChangeFeedBoxThree}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem
                                value="asc"
                                className="date-comp-menuitem"
                              >
                                <em className="date-comp-em">Ascending</em>
                              </MenuItem>
                              <MenuItem
                                value="desc"
                                className="date-comp-menuitem"
                              >
                                <em className="date-comp-em">Descending</em>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <div ref={boxThreeRef}>
                      {feedBoxThree?.data?.length ? (
                        <>
                          {keywordSelectedThree?.length ? (
                            <div className="display-kw-ci">
                              {keywordSelectedThree?.map((item) => (
                                <div className="crie_selected_names">
                                  {item}{" "}
                                  <CloseOutlined
                                    onClick={() => handleRemoveTags(item, 3)}
                                  />
                                </div>
                              ))}
                            </div>
                          ) : null}
                          {feedBoxThree.data.map((articleData, index) => (
                            <div
                              key={index}
                              className="rest-cont"
                              style={{ pageBreakInside: "avoid" }}
                            >
                              <div className="orbit-circle-text-comp">
                                <div className="jo-icon-comp">
                                  <p>
                                    {feedBoxThree?.boxData?.org_id
                                      ? initialData(
                                          feedBoxThree.boxData.org_name,
                                        )
                                      : feedBoxThree?.boxData?.first_name ||
                                          feedBoxThree?.boxData?.last_name
                                        ? initialData(
                                            `${
                                              feedBoxThree.boxData.first_name || ""
                                            } ${
                                              feedBoxThree.boxData.last_name || ""
                                            }`.trim(),
                                          )
                                        : feedBoxThree?.boxData?.location
                                          ? initialData(
                                              feedBoxThree?.boxData?.location,
                                            )
                                          : feedBoxThree?.boxData?.tags
                                            ? initialData(
                                                feedBoxThree?.boxData?.tags,
                                              )
                                            : feedBoxThree?.boxData?.industry
                                              ? initialData(
                                                  feedBoxThree?.boxData
                                                    ?.industry,
                                                )
                                              : feedBoxThree?.boxData
                                                    ?.request_id
                                                ? initialData(
                                                    allCustomSearchList?.find(
                                                      (i) =>
                                                        i?.request_id ===
                                                        feedBoxThree?.boxData
                                                          ?.request_id,
                                                    )?.custom_query_name,
                                                  )
                                                : null}
                                  </p>
                                </div>

                                <div className="updated-cont">
                                  <div>
                                    <p className="orbit-name-comp">
                                      {articleData?.article?.title
                                        ? articleData?.article?.title.length >
                                          25
                                          ? `${articleData?.article?.title.slice(
                                              0,
                                              25,
                                            )}...`
                                          : articleData?.article?.title
                                        : articleData?.title}
                                    </p>
                                  </div>
                                  <div className="both-news-time-comp">
                                    <p className="news-comp">
                                      <a
                                        href={
                                          articleData?.article?.url
                                            ? articleData?.article?.url
                                            : articleData?.public_text_link
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {articleData?.article?.url
                                          ? articleData.article.url.split(
                                              "https://",
                                            )[1]?.length > 15
                                            ? articleData.article.url
                                                .split("https://")[1]
                                                .slice(0, 15) + "..."
                                            : articleData.article.url.split(
                                                "https://",
                                              )[1]
                                          : articleData?.public_text_link.split(
                                                "http://",
                                              )[1]?.length > 15
                                            ? articleData?.public_text_link
                                                .split("http://")[1]
                                                .slice(0, 15) + "..."
                                            : articleData?.public_text_link.split(
                                                "http://",
                                              )[1]}
                                      </a>
                                      |
                                    </p>
                                    <p className="today-comp">
                                      {new Date(
                                        articleData?.article?.date
                                          ? articleData?.article?.date
                                          : articleData?.inserted_date,
                                      ).toLocaleDateString("en-US", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric",
                                      })}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="content-pera-comp">
                                <p className="bold-content-pera-comp">
                                  {expandedSummaryThree[index] ? (
                                    <>
                                      {articleData.summary}
                                      {articleData.summary.length > 170 && (
                                        <span
                                          onClick={() =>
                                            toggleSummaryThree(index)
                                          }
                                          className="see-more-btn"
                                          style={{
                                            color: "#001A54",
                                            cursor: "pointer",
                                            textDecoration: "none",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          Show Less
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {articleData.summary.length > 170
                                        ? `${articleData.summary.slice(
                                            0,
                                            articleData.summary.lastIndexOf(
                                              " ",
                                              170,
                                            ),
                                          )}`
                                        : articleData.summary}
                                      {articleData.summary.length > 170 && (
                                        <span
                                          onClick={() =>
                                            toggleSummaryThree(index)
                                          }
                                          className="see-more-btn"
                                          style={{
                                            color: "#001A54",
                                            cursor: "pointer",
                                            textDecoration: "none",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          See More
                                        </span>
                                      )}
                                    </>
                                  )}
                                </p>
                                <div className="Intersect-jb-nf-comp">
                                  {articleData?.tags?.map((tag, idx) => (
                                    <p key={idx}>
                                      {typeof tag === "string" ? tag : tag.tag}
                                    </p>
                                  ))}
                                </div>
                              </div>
                              <hr className="hr-tag-ci" />
                            </div>
                          ))}
                        </>
                      ) : (
                        <p className="text-center-result">No results found</p>
                      )}
                    </div>
                  </div>
                  {loadThree ? (
                    <div className="dash-cancel-save-btns">
                      <Button
                        className="de_next"
                        onClick={() => setSkipThree((skip) => skip + 10)}
                      >
                        Load More
                      </Button>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div
                  className="CI-cards col"
                  //  onClick={() => handleOpen(3)}
                  onClick={() => {
                    handleOpen(3);
                  }}
                >
                  <AddCircleIcon className="add-content-button" />{" "}
                  <p className="CI-card-content">Add Content</p>
                </div>
              )}
            </div>
          )}
        </>
      {/* Common Modal  */}
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style}>
            <div className="de_overflow_cont">
              <div className="dash-model-head">
                <h3>Select content for stream</h3>
                <CloseIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <hr />
              <div className="ci-outer">
                {openStateLegislation ? null : (
                  <div className="ci-tabs">
                    {feedBoxOne?.boxData?.id ? (
                      <div>Content One</div>
                    ) : (
                      <div
                        className={
                          value === 1 ? "ci-selected" : "ci-selected-mobile"
                        }
                        onClick={() => {
                          setValue(1);
                          setValueOrganization(false);
                          setValueIndustrySector(false);
                          setValueKeywordTracking(false);
                          setValuePeople(false);
                          setValueStates(false);
                          setValueCustomSearch(false);
                          setCommon(true);
                        }}
                      >
                        Content One
                      </div>
                    )}
                    {feedBoxTwo?.boxData?.id ? (
                      <div>Content Two</div>
                    ) : (
                      <div
                        className={
                          value === 2 ? "ci-selected" : "ci-selected-mobile"
                        }
                        onClick={() => {
                          setValue(2);
                          setValueOrganization(false);
                          setValueIndustrySector(false);
                          setValueKeywordTracking(false);
                          setValuePeople(false);
                          setValueStates(false);
                          setValueCustomSearch(false);
                          setCommon(true);
                        }}
                      >
                        Content Two
                      </div>
                    )}

                    {feedBoxThree?.boxData?.id ? (
                      <div>Content Three</div>
                    ) : (
                      <div
                        className={
                          value === 3 ? "ci-selected" : "ci-selected-mobile"
                        }
                        onClick={() => {
                          setValue(3);
                          setValueOrganization(false);
                          setValueIndustrySector(false);
                          setValueKeywordTracking(false);
                          setValuePeople(false);
                          setValueStates(false);
                          setValueCustomSearch(false);
                          setCommon(true);
                        }}
                      >
                        Content Three
                      </div>
                    )}
                  </div>
                )}
                {common ? (
                  <div className="ci-search">
                    <p
                      className="organization-search-ci"
                      onClick={handleOpenOrganization}
                    >
                      Organization
                    </p>
                    <p className="people-search-ci" onClick={handleOpenPeople}>
                      Prospects
                    </p>
                    <p
                      className="people-search-ci"
                      onClick={handleOpenKeywordTracking}
                    >
                      Keyword Tracking
                    </p>
                    {/* <p
                      className="news-events-search-ci"
                      onClick={handleOpenEvent}
                    >
                      News/Events

                    </p> */}
                    <p
                      className="news-events-search-ci"
                      onClick={handleOpenStates}
                    >
                      States
                    </p>
                    <p
                      className="people-search-ci"
                      onClick={handleOpenIndustrySector}
                    >
                      Industry/Sector
                    </p>
                    <p
                      className="people-search-ci"
                      onClick={handleOpenCustomSearch}
                    >
                      Custom Search
                    </p>
                    <div className="dash-cancel-save-btns">
                      <Button className="de_cancel" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button
                        className="de_next"
                        // onClick={saveContentFeed}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                ) : null}
                {valueOrganization ? (
                  <div className="ci-search-news-events">
                    <div className="news-event-search-modal">
                      <Paper
                        component="form"
                        sx={{
                          p: "2px 4px",

                          display: "flex",

                          alignItems: "center",

                          width: 400,
                        }}
                        className="full-searchbar-comp ci-searchbar"
                      >
                        <SearchIcon className="searchicon-in-header" />

                        <InputBase
                          className="search-inner-text"
                          sx={{ ml: 1, flex: 1 }}
                          placeholder="Search organization name"
                          inputProps={{ "aria-label": "Search" }}
                          autoComplete="off"
                          value={searchTextOrg}
                          onChange={(e) => setSearchTextOrg(e.target.value)}
                        />

                        {searchTextOrg && (
                          <CloseIcon
                            className="showicons-search"
                            onClick={() => {
                              setSearchTextOrg("");

                              handleTrackingOrganizations(0, 50, true, "");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </Paper>
                    </div>

                    {loading ? (
                      <p className="news-event-modal-text">Loading...</p>
                    ) : allOrgList?.length ? (
                      allOrgList?.map((org, index) => (
                        <p
                          key={index}
                          className="news-event-modal-text"
                          onClick={() => handleOrgClick(org)}
                          style={{
                            color:
                              selectedOrg?.org_id === org?.org_id
                                ? "red"
                                : "inherit",

                            cursor: "pointer",
                          }}
                        >
                          {org?.organization_name}
                        </p>
                      ))
                    ) : searchTextOrg?.length > 1 ? (
                      <p className="ci-news-disclaimer news-event-modal-text">
                        {" "}
                        If you don’t see the organization you were looking for
                        in this list, head over to the Competitive Intel section
                        to start tracking it.
                      </p>
                    ) : null}

                    {orgLoadMore && (
                      <div className="dash-cancel-save-btns-loadmore">
                        <Button
                          className="de_next"
                          onClick={() => {
                            const newSkip = skipOrganization + orgLimit;

                            setSkipOrganization(newSkip);

                            handleTrackingOrganizations(newSkip, orgLimit);
                          }}
                        >
                          Load More
                        </Button>
                      </div>
                    )}

                    <div className="dash-cancel-save-btns">
                      <Button className="de_cancel" onClick={handleBackorg}>
                        Back
                      </Button>

                      <Button className="de_cancel" onClick={handleClose}>
                        Cancel
                      </Button>

                      <Button className="de_next" onClick={saveContentFeed}>
                        Save
                      </Button>
                    </div>
                  </div>
                ) : null}
                {valuePeople ? (
                  <div className="ci-search-news-events">
                    <div className="news-event-search-modal">
                      <Paper
                        component="form"
                        sx={{
                          p: "2px 4px",

                          display: "flex",

                          alignItems: "center",

                          width: 400,
                        }}
                        className="full-searchbar-comp ci-searchbar"
                      >
                        <SearchIcon className="searchicon-in-header" />

                        <InputBase
                          className="search-inner-text"
                          sx={{ ml: 1, flex: 1 }}
                          placeholder="Search prospect names"
                          inputProps={{ "aria-label": "Search" }}
                          autoComplete="off"
                          value={searchTextPeople}
                          onChange={(e) => setSearchTextPeople(e.target.value)}
                        />

                        {searchTextPeople && (
                          <CloseIcon
                            className="showicons-search"
                            onClick={() => {
                              setSearchTextPeople("");

                              handleTrackingProspects(0, 50, true, "");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </Paper>
                    </div>

                    {loading ? (
                      <p className="news-event-modal-text">Loading...</p>
                    ) : allPeopleList?.length ? (
                      allPeopleList?.map((people, index) => (
                        <p
                          key={index}
                          className="news-event-modal-text"
                          onClick={() => handlePeopleClick(people)}
                          style={{
                            color:
                              selectedPeople?.person_id === people?.person_id
                                ? "red"
                                : "inherit",

                            cursor: "pointer",
                          }}
                        >
                          {people?.first_name === "jp"
                            ? "JP"
                            : people?.first_name}{" "}
                          {people?.last_name}
                        </p>
                      ))
                    ) : searchTextPeople?.length > 1 ? (
                      <p className="ci-news-disclaimer news-event-modal-text">
                        {" "}
                        If you don’t see the Prospect you were looking for in
                        this list, head over to the Competitive Intel section to
                        start tracking it.
                      </p>
                    ) : null}

                    {peopleLoadMore && (
                      <div className="dash-cancel-save-btns-loadmore">
                        <Button
                          className="de_next"
                          onClick={() => {
                            const newSkip = skipPeople + orgLimitPeople;

                            setSkipPeople(newSkip);

                            handleTrackingProspects(newSkip, orgLimitPeople);
                          }}
                        >
                          Load More
                        </Button>
                      </div>
                    )}

                    <div className="dash-cancel-save-btns">
                      <Button className="de_cancel" onClick={handleBackPeople}>
                        Back
                      </Button>

                      <Button className="de_cancel" onClick={handleClose}>
                        Cancel
                      </Button>

                      <Button className="de_next" onClick={saveContentFeed}>
                        Save
                      </Button>
                    </div>
                  </div>
                ) : null}
                {valueKeywordTracking ? (
                  <div className="ci-search-news-events">
                    <div className="news-event-search-modal">
                      <Paper
                        component="form"
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                          width: 400,
                        }}
                        className="full-searchbar-comp ci-searchbar"
                      >
                        <SearchIcon className="searchicon-in-header" />
                        <InputBase
                          className="search-inner-text"
                          sx={{ ml: 1, flex: 1 }}
                          placeholder="Search keywords"
                          inputProps={{ "aria-label": "Search" }}
                          autoComplete="off"
                          value={searchTextKeyword}
                          onChange={(e) => setSearchTextKeyword(e.target.value)}
                        />
                        {searchTextKeyword && (
                          <CloseIcon
                            className="showicons-search"
                            onClick={() => setSearchTextKeyword("")}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </Paper>
                    </div>

                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      filteredKeywords?.map((keyword, index) => (
                        <div className="news-event-modal-text">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedKeyword?.includes(keyword)}
                                value={keyword}
                                onChange={(event) =>
                                  handleKeywordCheckboxChange(event, keyword)
                                }
                                className="checkbox-green ci-check-modal"
                                color="success"
                              />
                            }
                            label={<MenuItem>{keyword}</MenuItem>}
                          />
                        </div>
                      ))
                    )}
                    <div className="dash-cancel-save-btns">
                      <Button className="de_cancel" onClick={handleBackKeyword}>
                        Back
                      </Button>
                      <Button className="de_cancel" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button className="de_next" onClick={saveContentFeed}>
                        Save
                      </Button>
                    </div>
                  </div>
                ) : null}
                {valueIndustrySector ? (
                  <div className="ci-search-news-events">
                    <div className="news-event-search-modal">
                      <Paper
                        component="form"
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                          width: 400,
                        }}
                        className="full-searchbar-comp ci-searchbar"
                      >
                        <SearchIcon className="searchicon-in-header" />
                        <InputBase
                          className="search-inner-text"
                          sx={{ ml: 1, flex: 1 }}
                          placeholder="Search industries"
                          inputProps={{ "aria-label": "Search" }}
                          autoComplete="off"
                          value={searchTextIndustry}
                          onChange={(e) =>
                            setSearchTextIndustry(e.target.value)
                          }
                        />
                        {searchTextIndustry && (
                          <CloseIcon
                            className="showicons-search"
                            onClick={() => setSearchTextIndustry("")}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </Paper>
                    </div>

                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      filteredIndustries?.map((industry, index) => (
                        <div className="news-event-modal-text">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedIndustry?.includes(industry)}
                                value={industry}
                                onChange={(event) =>
                                  handleIndustryCheckboxChange(event, industry)
                                }
                                className="checkbox-green ci-check-modal"
                                color="success"
                              />
                            }
                            label={<MenuItem>{industry}</MenuItem>}
                          />
                        </div>
                      ))
                    )}
                    <div className="dash-cancel-save-btns">
                      <Button
                        className="de_cancel"
                        onClick={handleBackIndustry}
                      >
                        Back
                      </Button>
                      <Button className="de_cancel" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button className="de_next" onClick={saveContentFeed}>
                        Save
                      </Button>
                    </div>
                  </div>
                ) : null}
                {valueStates ? (
                  <div className="ci-search-news-events">
                    <div className="news-event-search-modal">
                      <Paper
                        component="form"
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                          width: 400,
                        }}
                        className="full-searchbar-comp ci-searchbar"
                      >
                        <SearchIcon className="searchicon-in-header" />
                        <InputBase
                          className="search-inner-text"
                          sx={{ ml: 1, flex: 1 }}
                          placeholder="Search States…"
                          inputProps={{ "aria-label": "Search" }}
                          autoComplete="off"
                          value={searchTextState}
                          onChange={(e) => setSearchTextState(e.target.value)}
                        />
                        {searchTextState && (
                          <CloseIcon
                            className="showicons-search"
                            onClick={() => setSearchTextState("")}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </Paper>
                    </div>

                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      filteredStates?.map((location, index) => (
                        <p
                          key={index}
                          className={
                            CompetitiveStatesList.includes(location)
                              ? "news-event-modal-text-bg"
                              : "news-event-modal-text"
                          }
                          onClick={() => handleStatesClick(location)}
                          style={{
                            color:
                              selectedState === location ? "red" : "inherit",
                            cursor: "pointer",
                          }}
                        >
                          {location}
                        </p>
                      ))
                    )}
                    <div className="dash-cancel-save-btns">
                      <Button className="de_cancel" onClick={handleBackStates}>
                        Back
                      </Button>
                      <Button className="de_cancel" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button
                        className="de_next"
                        onClick={() => {
                          setValueStates(false);
                          setOpenStateLegislation(true);
                        }}
                      >
                        Next
                      </Button>
                    </div>
                  </div>
                ) : null}
                {openStateLegislation ? (
                  <div className="ci-search-news-events-legislation">
                    <h3 className="type-of-list-ci">
                      Please select what type of content do you want to stream
                    </h3>
                    <div className="type-of-list-fav-body">
                      <RadioGroup
                        value={selectedStateLegislation}
                        onChange={(e) =>
                          setSelectedStateLegislation(e.target.value)
                        }
                        className="radio-ci-state"
                      >
                        <FormControlLabel
                          className="radio-btn-fav-mdl"
                          value="news"
                          control={<Radio />}
                          label="News & Events"
                        />
                        <FormControlLabel
                          className="radio-btn-fav-mdl"
                          value="legislation"
                          control={<Radio />}
                          label="Legislation"
                        />
                      </RadioGroup>
                      <div className="dash-cancel-save-btns">
                        <Button
                          className="de_cancel"
                          onClick={() => {
                            setValueStates(true);
                            setOpenStateLegislation(false);
                          }}
                        >
                          Back
                        </Button>
                        <Button className="de_cancel" onClick={handleClose}>
                          Cancel
                        </Button>
                        <Button
                          className="de_next"
                          onClick={() => {
                            saveContentFeed();
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                ) : null}
                {valueCustomSearch ? (
                  <div className="ci-search-news-events">
                    <div className="news-event-search-modal">
                      <Paper
                        component="form"
                        sx={{
                          p: "2px 4px",
                          display: "flex",
                          alignItems: "center",
                          width: 400,
                        }}
                        className="full-searchbar-comp ci-searchbar"
                      >
                        <SearchIcon className="searchicon-in-header" />
                        <InputBase
                          className="search-inner-text"
                          sx={{ ml: 1, flex: 1 }}
                          placeholder="Search"
                          inputProps={{ "aria-label": "Search" }}
                          autoComplete="off"
                          value={searchTextCustomSearch}
                          onChange={(e) =>
                            setSearchTextCustomSearch(e.target.value)
                          }
                        />
                        {searchTextCustomSearch && (
                          <CloseIcon
                            className="showicons-search"
                            onClick={() => setSearchTextCustomSearch("")}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </Paper>
                    </div>

                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      filteredCustomSearchs?.map((location, index) => (
                        <p
                          key={index}
                          className="news-event-modal-text"
                          onClick={() => handleCustomSearchClick(location)}
                          style={{
                            color:
                              selectedCustomSearch?.request_id ===
                              location?.request_id
                                ? "red"
                                : "inherit",
                            cursor: "pointer",
                          }}
                        >
                          {location?.custom_query_name}
                        </p>
                      ))
                    )}
                    <div className="dash-cancel-save-btns">
                      <Button
                        className="de_cancel"
                        onClick={handleBackCustomSearch}
                      >
                        Back
                      </Button>
                      <Button className="de_cancel" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button className="de_next" onClick={saveContentFeed}>
                        Save
                      </Button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </Box>
        </div>
      </Modal>

      <CompetitiveSlider
        openCompetitiveSlide={openCompetitiveSlide}
        setOpenCompetitiveSlide={setOpenCompetitiveSlide}
        feedBoxOne={feedBoxOne}
        allCustomSearchList={allCustomSearchList}
        keywordAddModalOne={keywordAddModalOne}
        setKeywordAddModalOne={setKeywordAddModalOne}
        keywordListOne={keywordListOne}
        keywordSelectedOne={keywordSelectedOne}
        setKeywordSelectedOne={setKeywordSelectedOne}
        expandedSummaryOne={expandedSummaryOne}
        loadOne={loadOne}
        setSkipOne={setSkipOne}
        searchOneApi={searchOneApi}
        setSearchOneApi={setSearchOneApi}
        saveSearchOne={saveSearchOne}
        setSaveSearchOne={setSaveSearchOne}
        openSearchOne={openSearchOne}
        setOpenSearchOne={setOpenSearchOne}
        dateOrderOne={dateOrderOne}
        halflines={halflines}
        initialData={initialData}
        handleRemoveFeed={handleRemoveFeed}
        toggleSummaryOne={toggleSummaryOne}
        HandlePrintOne={HandlePrintOne}
        download={download}
        handleToPDF={handleToPDF}
        handleRemoveTags={handleRemoveTags}
        search={search}
        getNews={getNews}
        handleChangeFeedBoxOne={handleChangeFeedBoxOne}
      />

      <CompetitiveSliderTwo
        openCompetitiveSlide={openCompetitiveSlideTwo}
        setOpenCompetitiveSlide={setOpenCompetitiveSlideTwo}
        feedBoxOne={feedBoxTwo}
        allCustomSearchList={allCustomSearchList}
        keywordAddModalOne={keywordAddModalTwo}
        setKeywordAddModalOne={setKeywordAddModalTwo}
        keywordListOne={keywordListTwo}
        keywordSelectedOne={keywordSelectedTwo}
        setKeywordSelectedOne={setKeywordSelectedTwo}
        expandedSummaryOne={expandedSummaryTwo}
        loadOne={loadTwo}
        setSkipOne={setSkipTwo}
        searchOneApi={searchTwoApi}
        setSearchOneApi={setSearchTwoApi}
        saveSearchOne={saveSearchTwo}
        setSaveSearchOne={setSaveSearchTwo}
        openSearchOne={openSearchTwo}
        setOpenSearchOne={setOpenSearchTwo}
        dateOrderOne={dateOrderTwo}
        halflines={halflines}
        initialData={initialData}
        handleRemoveFeed={handleRemoveFeed}
        toggleSummaryOne={toggleSummaryTwo}
        HandlePrintOne={HandlePrintTwo}
        download={download}
        handleToPDF={handleToPDF}
        handleRemoveTags={handleRemoveTags}
        search={search}
        getNews={getNews}
        handleChangeFeedBoxOne={handleChangeFeedBoxTwo}
      />

      <CompetitiveSliderThree
        openCompetitiveSlide={openCompetitiveSlideThree}
        setOpenCompetitiveSlide={setOpenCompetitiveSlideThree}
        feedBoxOne={feedBoxThree}
        allCustomSearchList={allCustomSearchList}
        keywordAddModalOne={keywordAddModalThree}
        setKeywordAddModalOne={setKeywordAddModalThree}
        keywordListOne={keywordListThree}
        keywordSelectedOne={keywordSelectedThree}
        setKeywordSelectedOne={setKeywordSelectedThree}
        expandedSummaryOne={expandedSummaryThree}
        loadOne={loadThree}
        setSkipOne={setSkipThree}
        searchOneApi={searchThreeApi}
        setSearchOneApi={setSearchThreeApi}
        saveSearchOne={saveSearchThree}
        setSaveSearchOne={setSaveSearchThree}
        openSearchOne={openSearchThree}
        setOpenSearchOne={setOpenSearchThree}
        dateOrderOne={dateOrderThree}
        halflines={halflines}
        initialData={initialData}
        handleRemoveFeed={handleRemoveFeed}
        toggleSummaryOne={toggleSummaryThree}
        HandlePrintOne={HandlePrintThree}
        download={download}
        handleToPDF={handleToPDF}
        handleRemoveTags={handleRemoveTags}
        search={search}
        getNews={getNews}
        handleChangeFeedBoxOne={handleChangeFeedBoxThree}
      />
    </>
  );
};
export default CompetitiveIntelligence;
